import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  TableContainer,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Table,
  CircularProgress,
  Modal,
  Slide,
  Alert,
  CardMedia,
  IconButton,
  Tooltip,
  Collapse,
  Checkbox,
  Paper,
  List,
  ListItemIcon,
  ListItemButton,
  Tabs,
  Tab,
  Stack,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { ListItemText } from "@mui/material";
import {
  appointmentResearchNew,
  CommonFieldsData,
  datiPacada,
  datiPacadc,
  datiPacapr,
  datiPrenotazione,
  generalResearch,
  manageAppointment,
  parPacaric,
  performance,
  printPDF,
  ripriPacadc,
  specialities,
} from "../../networking";
import "../../css/appointmentResearch.css";
import CircleIcon from "@mui/icons-material/Circle";
import redTrashBin from "../../assets/icons/RedTrashBin.svg";
import iconCard from "../../assets/Icons-desktop.svg";
import blackPencil from "../../assets/icons/BlackPencil.svg";
import pdfIconBlack from "../../assets/icons/BlackPdfIcon.svg";
import changeAppointmentIcon from "../../assets/icons/ChangeAppointment.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import iconaEsporta from "../../assets/icons/Icon-export_blue.svg";
import bluePencil from "../../assets/icons/Icon-bluePencil.svg";
import iconaSpuntaAppuntamento from "../../assets/icons/iconAppuntamentoSpunta.svg";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import {
  AppointmentData,
  DataPrestazioneToEdit,
  Performance,
  Specialty,
} from "../../services/interfaces";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { DataGrid, GridColDef, itIT } from "@mui/x-data-grid";
import { AllertMessage } from "../DoctorsList/Medint/MedintDetails/MedintDetails";
import AppointmentListDetail, {
  PacadaPayload,
} from "./AppointmentListDetail/AppointmentListDetail";
import "dayjs/locale/it";
import AppointmentDeletedListDetail from "./AppointmentListDetail/AppointmentDeletedListDetail";
import AppointmentDetailPanel from "./AppointmentDetailPanel/AppointmentDetailPanel";
import { Enti } from "../AppointmentManagement/AppointmentManagement";
import { RHFAutocomplete } from "../RHFComponents/RHFComponents";

dayjs.locale("it");

export interface TabRuoli {
  CODTABRUOLI: string;
  DESTABRUOLI: string;
  CANALEPREN: string;
}

export interface PosTick {
  CODPOSTIC: string;
  DESPOSTIC: string;
  DATAINIVAL: string;
  DATAFINEVAL: string;
}

export interface RicRipe {
  CODRICRIPE: string;
  DESRICRIPE: string;
}

//#region LOGICHE CONTROLLI TEXTFIELDS
type ControlFunction = (
  regex: RegExp,
  formValues: any,
  setMiddleState: Dispatch<SetStateAction<boolean>>,
  setIsValid: Dispatch<SetStateAction<boolean>>,
  errorMessage: string,
  lengthErrorMessage: string,
  setMessage: Dispatch<SetStateAction<string>>,
  maxLength: number[]
) => void;

// Logiche delle Regex
const SOLO_NUMS_REGEX = /^[0-9]*$/;
const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]+$/;

// const controlFunction: ControlFunction = (
//   regex,
//   formValues,
//   setMiddleState,
//   setIsValid,
//   errorMessage,
//   lengthErrorMessage,
//   setMessage,
//   maxLength
// ) => {
//   const maxLengthExceded =
//     (formValues?.length ?? 0) <= maxLength ? false : true;

//   if (maxLengthExceded) {
//     setIsValid(false);
//     setMessage(lengthErrorMessage);
//   }

//   // controllo sulla regex, che l'input di partenza sia vuoto e la lunghezza non ecceda
//   if (
//     (regex.test(formValues) || regex.test("") || formValues === "") &&
//     !maxLengthExceded
//   ) {
//     setIsValid(true);
//     if (
//       formValues?.length === 0 ||
//       formValues === undefined ||
//       formValues?.length === maxLength
//     ) {
//       setMiddleState(false);
//     } else {
//       setMiddleState(true);
//     }
//   } else {
//     setIsValid(false);
//     setMessage(errorMessage);
//   }
// };

const controlFunction: ControlFunction = (
  regex,
  formValues,
  setMiddleState,
  setIsValid,
  errorMessage,
  lengthErrorMessage,
  setMessage,
  maxLengths
) => {
  const allowedLengths = Array.isArray(maxLengths) ? maxLengths : [maxLengths];

  const maxAllowed = Math.max(...allowedLengths);
  const maxLengthExceeded = (formValues?.length ?? 0) > maxAllowed;

  if (maxLengthExceeded) {
    setIsValid(false);
    setMessage(lengthErrorMessage);
    return;
  }

  if (
    (regex.test(formValues) || regex.test("") || formValues === "") &&
    !maxLengthExceeded
  ) {
    setIsValid(true);

    if (
      formValues?.length === 0 ||
      formValues === undefined ||
      allowedLengths.includes(formValues.length)
    ) {
      setMiddleState(false);
    } else {
      setMiddleState(true);
    }
  } else {
    setIsValid(false);
    setMessage(errorMessage);
  }
};
//#endregion

//esiste perché cambiano convenzione continuamente di come vogliono ricevere il nome e il cognome in ingresso
interface CompletoPaziente {
  id: string;
  nome: string;
  cognome: string;
  dataNascita: string;
}

// struttura oggetto per la gestione dei resets vari che possono occorrere durante l'interazione dell'utente sul workflow
interface RiferimentiIDsIstanzaPrenotazione {
  azienda: string;
  numPrenotazione: string;
  idpacate: string;
  idpacapr: string;
}

type StateFormCancellazione = {
  daPagare: boolean;
  sospeso: boolean;
  noteCancellazione: string;
};

export interface AppointmentsByPACAPRE {
  NUMERO_PRESTAZIONE: string;
  DESCRIZIONE_PRESTAZIONE: string;
  GRUPPO_APPUNTAMENTI: AppointmentData[];
}

export interface AppoinmentsByPRENOTAZIONE {
  NUMERO_PRENOTAZIONE: string;
  IDPACADA: string;
  IDPACATA: string;
  IDPACAPR: string;
  NOME_PAZIENTE: string;
  DATA_NASCITA: string;
  SPECIALITA: string;
  TIPO_AGENDA: string;
  STATO_PRENOTAZIONE: string;
  GRUPPO_PRESTAZIONI: AppointmentsByPACAPRE[];
  DATAPRENOTAZIONE: string;
  AZIENDAPRENOTAZIONE: string;
}

export interface AppointmentResearchDettaglioPrenotazione {
  numeroPrenotazione: string;
  dataPrenotazione: string;
  idPrenotazione: string;
  totPrenotazione: string;
  paziente: string;
  dataDiNascita: string;
  sesso: string;
  telefono: string;
  praticaRicovero: string;
  idPaziente: string;
  origine: {
    sysClinique: string;
    gp: string;
    g2: string;
    tuoTempo: string;
    web: string;
    flussoMta: string;
    eclaim: string;
  };
  temporaneo: boolean;
  ruoloOperatore: string;
  aslPrenotazione: string;
  notePrenotazione: string;
}

// funzione per formattare una stringa
export const formatHour = (time: any) => {
  if (!time || typeof time !== "string") {
    return "";
  }
  const timeString = time.toString().padStart(4, "0");

  const hours = timeString.substring(0, 2);
  const minutes = timeString.substring(2);

  return `${hours}:${minutes}`;
};

function AllertConfirmEdit(props: {
  showAllertEdit: boolean;
  setAllertEdit: (value: boolean) => void;
  appointmentToEdit: AppointmentData | undefined;
  appointmentsList: AppointmentsByPACAPRE | undefined;
  handleEditConfirmation: (
    value: AppointmentData,
    appointmentsList: AppointmentsByPACAPRE
  ) => void;
}) {
  return (
    <Modal open={props.showAllertEdit}>
      <Slide in={props.showAllertEdit} direction="down" timeout={800}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
            "& .MuiPaper-root": {
              paddingRight: 5,
              paddingLeft: 5,
            },
          }}
        >
          <Alert
            severity={"warning"}
            action={
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="containedError"
                  size="small"
                  onClick={() => {
                    props.setAllertEdit(false);
                  }}
                >
                  Annulla
                </Button>
                <Button
                  variant="containedCustom"
                  size="small"
                  onClick={() => {
                    if (props.appointmentToEdit && props.appointmentsList) {
                      props.handleEditConfirmation(
                        props.appointmentToEdit,
                        props.appointmentsList
                      );
                    }
                  }}
                >
                  Conferma
                </Button>
              </Box>
            }
            sx={{
              maxWidth: "150vh",
              width: "90%",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              transform: "translate3d(20%, 100%, 0%)",
              flexDirection: "row",
              "& .MuiAlert-icon": {
                fontSize: 30,
              },
            }}
          >
            <Typography
              component="div"
              marginTop={"20px"}
              marginLeft={"20px"}
              marginRight={"10px"}
              marginBottom={"20px"}
              fontSize={"20px"}
              fontStyle={"capitalize"}
            >
              Sicuro di voler modificare la data dell'appuntamento?
            </Typography>
          </Alert>
        </Box>
      </Slide>
    </Modal>
  );
}

function AllertConfirmDelete(props: {
  showAllertDelete: boolean;
  setAllertDelete: (value: boolean) => void;
  handleDeleteConfirmation: () => void;
}) {
  return (
    <Modal open={props.showAllertDelete}>
      <Slide in={props.showAllertDelete} direction="down" timeout={800}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
            "& .MuiPaper-root": {
              paddingRight: 5,
              paddingLeft: 5,
            },
          }}
        >
          <Alert
            severity={"warning"}
            action={
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="containedError"
                  size="small"
                  onClick={() => {
                    props.setAllertDelete(false);
                  }}
                >
                  Annulla
                </Button>
                <Button
                  variant="containedCustom"
                  size="small"
                  onClick={() => {
                    props.handleDeleteConfirmation();
                  }}
                >
                  Conferma
                </Button>
              </Box>
            }
            sx={{
              maxWidth: "150vh",
              width: "90%",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              transform: "translate3d(20%, 100%, 0%)",
              flexDirection: "row",
              "& .MuiAlert-icon": {
                fontSize: 30,
              },
            }}
          >
            <Typography
              component="div"
              marginTop={"20px"}
              marginLeft={"20px"}
              marginRight={"10px"}
              marginBottom={"20px"}
              fontSize={"20px"}
              fontStyle={"capitalize"}
            >
              Sei sicuro di voler cancellare l'appuntamento?
            </Typography>
          </Alert>
        </Box>
      </Slide>
    </Modal>
  );
}

const StoricoAnnullamenti = (props: {
  appuntamentiAnnullati: any;
  handleOnClickDettaglioAppuntamento: (params: any) => void;
  handleOnClickRipristinoAppuntamento: (params: any) => void;
  handleOnClickUscita: () => void;
  askConfirmEditPrenotazione: () => void;
  askConfirmCancellazioneFisicaAppuntamentoCancellato: (params: any) => void;
  askConfirmRipristinoAppuntamento: (params: any) => void;
}) => {
  const columns: GridColDef[] = [
    {
      field: "idPacaDc",
      headerName: "ID",
      editable: false,
    },
    {
      field: "dataVisita",
      headerName: "Data Visita",
      editable: false,
      flex: 1,
      valueFormatter: (params) =>
        params.value &&
        dayjs(params.value, ["YYYY-MM-DD", "DD/MM/YYYY"]).isValid()
          ? dayjs(params.value, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("DD/MM/YY")
          : "",
    },
    {
      field: "ora",
      headerName: "Ora",
      editable: false,
      flex: 1,
      valueFormatter: (params) => {
        if (!params.value) return "";

        // Se è a 3 cifre, aggiungo uno zero davanti eventualità da gestire..
        if (params.value.length === 3) params.value = "0" + params.value;

        const parsed = dayjs(params.value, ["HHmm", "HH:mm"], true);

        return parsed.isValid() ? parsed.format("HH:mm") : params.value;
      },
    },
    {
      field: "durata",
      headerName: "Durata",
      editable: false,
      flex: 1,
      renderCell: (params) => {
        return `${params.value}'`;
      },
    },
    {
      field: "medico",
      headerName: "Medico",
      editable: false,
      flex: 2,
    },
    {
      field: "stato",
      headerName: "Stato",
      editable: false,
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
            height="100%"
          >
            {params.value === "Sospeso" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <circle cx="8" cy="8" r="8" fill="#FFE91E" />
              </svg>
            )}
            {params.value === "Annullato" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <circle cx="8" cy="8" r="8" fill="#FF473D" />
              </svg>
            )}
            <span>{params.value}</span>
          </Box>
        );
      },
    },
    {
      field: "azioni",
      headerName: "Azioni",
      align: "center",
      editable: false,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          <Tooltip title={"Modifica"}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                props.handleOnClickDettaglioAppuntamento(params.row);
              }}
              disabled={params.row.stato === "Sospeso"}
            >
              <CardMedia
                component="svg"
                sx={{ height: 20, width: 20 }}
                {...(params.row.stato === "Sospeso" && {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 16 16",
                })}
              >
                {params.row.stato === "Sospeso" ? (
                  <path
                    d="M14.2069 4.58561L11.4144 1.79249C11.3215 1.6996 11.2113 1.62592 11.0899 1.57565C10.9686 1.52539 10.8385 1.49951 10.7072 1.49951C10.5759 1.49951 10.4458 1.52539 10.3245 1.57565C10.2031 1.62592 10.0929 1.6996 10 1.79249L2.29313 9.49998C2.19987 9.59251 2.12593 9.70265 2.0756 9.824C2.02528 9.94535 1.99959 10.0755 2.00001 10.2069V13C2.00001 13.2652 2.10536 13.5196 2.2929 13.7071C2.48043 13.8946 2.73479 14 3.00001 14H5.79313C5.9245 14.0004 6.05464 13.9747 6.17599 13.9244C6.29735 13.8741 6.40748 13.8001 6.50001 13.7069L14.2069 5.99999C14.2998 5.90712 14.3734 5.79687 14.4237 5.67553C14.474 5.55419 14.4999 5.42414 14.4999 5.2928C14.4999 5.16146 14.474 5.0314 14.4237 4.91006C14.3734 4.78872 14.2998 4.67847 14.2069 4.58561ZM3.20688 9.99998L8.85376 4.35311L9.89626 5.39624L4.25001 11.0425L3.20688 9.99998ZM3.00001 11.2069L4.79313 13H3.00001V11.2069ZM6.00001 12.7931L4.95688 11.75L10.6038 6.10311L11.6463 7.14623L6.00001 12.7931Z"
                    fill="#C8C8C8"
                  />
                ) : (
                  <image href={bluePencil} height="20" width="20" />
                )}
              </CardMedia>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Ripristina"}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                props.askConfirmRipristinoAppuntamento(params.row);
              }}
              disabled={params.row.stato === "Sospeso"}
            >
              <CardMedia
                component="svg"
                sx={{ height: 20, width: 20 }}
                {...(params.row.stato === "Sospeso" && {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 16 16",
                })}
              >
                {params.row.stato === "Sospeso" ? (
                  <path
                    d="M14 8.99991V12.9999C14 13.1325 13.9473 13.2597 13.8536 13.3535C13.7598 13.4472 13.6326 13.4999 13.5 13.4999H2.5C2.36739 13.4999 2.24021 13.4472 2.14645 13.3535C2.05268 13.2597 2 13.1325 2 12.9999V8.99991C2 8.8673 2.05268 8.74012 2.14645 8.64635C2.24021 8.55258 2.36739 8.49991 2.5 8.49991C2.63261 8.49991 2.75979 8.55258 2.85355 8.64635C2.94732 8.74012 3 8.8673 3 8.99991V12.4999H13V8.99991C13 8.8673 13.0527 8.74012 13.1464 8.64635C13.2402 8.55258 13.3674 8.49991 13.5 8.49991C13.6326 8.49991 13.7598 8.55258 13.8536 8.64635C13.9473 8.74012 14 8.8673 14 8.99991ZM5.85375 4.85366L7.5 3.20678V8.99991C7.5 9.13251 7.55268 9.25969 7.64645 9.35346C7.74022 9.44723 7.86739 9.4999 8 9.4999C8.13261 9.4999 8.25979 9.44723 8.35355 9.35346C8.44732 9.25969 8.5 9.13251 8.5 8.99991V3.20678L10.1462 4.85366C10.2401 4.94748 10.3673 5.00018 10.5 5.00018C10.6327 5.00018 10.7599 4.94748 10.8538 4.85366C10.9476 4.75984 11.0003 4.63259 11.0003 4.49991C11.0003 4.36722 10.9476 4.23998 10.8538 4.14615L8.35375 1.64615C8.30731 1.59967 8.25217 1.56279 8.19147 1.53763C8.13077 1.51246 8.06571 1.49951 8 1.49951C7.93429 1.49951 7.86923 1.51246 7.80853 1.53763C7.74783 1.56279 7.69269 1.59967 7.64625 1.64615L5.14625 4.14615C5.05243 4.23998 4.99972 4.36722 4.99972 4.49991C4.99972 4.63259 5.05243 4.75984 5.14625 4.85366C5.24007 4.94748 5.36732 5.00018 5.5 5.00018C5.63268 5.00018 5.75993 4.94748 5.85375 4.85366Z"
                    fill="#C8C8C8"
                  />
                ) : (
                  <image href={iconaEsporta} height="20" width="20" />
                )}
              </CardMedia>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Cancella"}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                // console.log(params.row);
                props.askConfirmCancellazioneFisicaAppuntamentoCancellato(
                  params.row
                );
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  height: {
                    md: 20,
                  },
                  width: {
                    md: 20,
                  },
                }}
                image={redTrashBin}
              />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", width: "100%" }}
      borderRadius={2}
      padding={2}
    >
      <Grid container>
        <Grid item xs={12}>
          <DataGrid
            sx={{
              border: "1px solid #ccc",
              width: "100%",
              borderRadius: 2,
              height: 180,
              display: "flex",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#003267",
                color: "#FFFFFF",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#F8F9FC",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#FFFFFF",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                color: "#FFFFFF",
              },
              "& .MuiDataGrid-iconButtonContainer": {
                color: "#FFFFFF",
              },
              "& .MuiDataGrid-sortIcon": {
                color: "#FFFFFF",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none",
                },
            }}
            rows={props.appuntamentiAnnullati}
            columns={columns}
            headerHeight={36}
            rowHeight={36}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  idPacaDc: false,
                },
              },
            }}
            hideFooter
            getRowId={(row) => `${row?.idPacaDc}`}
            localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
            disableColumnFilter
            disableColumnSelector
            disableColumnMenu
          />
        </Grid>
        <Grid item xs={12} paddingTop={2}>
          <Grid
            container
            display={"flex"}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Button
                variant="outlinedError"
                onClick={props.handleOnClickUscita}
                size="small"
                sx={{ color: "red !important", borderColor: "red !important" }}
              >
                Uscita
              </Button>
            </Grid>
            <Stack direction="row" spacing={2}>
              <Button variant="outlinedCustom" size="small">
                Acc. Manuale
              </Button>
              <Button variant="outlinedCustom" size="small">
                Log GP
              </Button>
              <Button
                variant="containedCustom"
                size="small"
                onClick={() => {
                  props.askConfirmEditPrenotazione();
                }}
              >
                Conferma
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

// Funzione di raggruppamento per PRENOTAZIONE, PRESTAZIONE, DATA
const valorizeGroupedAppointments = (
  appointmentsToFormat: AppoinmentsByPRENOTAZIONE[],
  originAppointments: AppointmentData[]
) => {
  let appointmentsByDateLenght: number = originAppointments.length;

  for (let i = 0; i < appointmentsByDateLenght; i++) {
    let foundPrenotazione = false;

    for (let j = 0; j < appointmentsToFormat.length; j++) {
      if (
        originAppointments[i].PRENOTAZIONE ===
        appointmentsToFormat[j].NUMERO_PRENOTAZIONE
      ) {
        foundPrenotazione = true;
        let foundPACAPR = false;

        for (
          let k = 0;
          k < appointmentsToFormat[j].GRUPPO_PRESTAZIONI.length;
          k++
        ) {
          if (
            originAppointments[i].IDPACAPR ===
            appointmentsToFormat[j].GRUPPO_PRESTAZIONI[k].NUMERO_PRESTAZIONE
          ) {
            appointmentsToFormat[j].GRUPPO_PRESTAZIONI[
              k
            ].GRUPPO_APPUNTAMENTI.push(originAppointments[i]);

            foundPACAPR = true;
            break;
          }
        }

        if (!foundPACAPR) {
          appointmentsToFormat[j].GRUPPO_PRESTAZIONI.push({
            NUMERO_PRESTAZIONE: originAppointments[i].IDPACAPR,
            DESCRIZIONE_PRESTAZIONE: originAppointments[i].DESCRESAME,
            GRUPPO_APPUNTAMENTI: [originAppointments[i]],
          });
        }
      }
    }

    if (!foundPrenotazione) {
      appointmentsToFormat.push({
        AZIENDAPRENOTAZIONE: originAppointments[i].AZIENDAPRENOTAZIONE,
        DATAPRENOTAZIONE: originAppointments[i].DATAPRENOTAZIONE,
        NUMERO_PRENOTAZIONE: originAppointments[i].PRENOTAZIONE,
        IDPACATA: originAppointments[i].IDPACATE,
        IDPACADA: originAppointments[i].IDPACADA,
        IDPACAPR: originAppointments[i].IDPACAPR,
        NOME_PAZIENTE: originAppointments[i].COGNOMEPAZIENTE.concat(
          " ",
          originAppointments[i].NOMEPAZIENTE
        ),
        DATA_NASCITA: originAppointments[i].DATANASCITA,
        SPECIALITA: originAppointments[i].DESCRSPECIALITA,
        TIPO_AGENDA: originAppointments[i].TIPOAGENDA,
        STATO_PRENOTAZIONE: originAppointments[i].STATOPRENOTAZIONE,
        GRUPPO_PRESTAZIONI: [
          {
            NUMERO_PRESTAZIONE: originAppointments[i].IDPACAPR,
            DESCRIZIONE_PRESTAZIONE: originAppointments[i].DESCRESAME,
            GRUPPO_APPUNTAMENTI: [originAppointments[i]],
          },
        ],
      });
    }
  }
};

const AppointmentResearch = () => {
  const [accordion, setAccordion] = useState<boolean>(true);
  const [loadingData, setLoadingData] = useState<boolean | null>(null);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [appointmentData, setAppointmentData] = useState<AppointmentData[]>([]);
  const [groupedAppointmentData, setGroupedAppointmentData] = useState<
    AppoinmentsByPRENOTAZIONE[]
  >([]);
  const [hasSearched, setHasSearched] = useState(false);

  const methodsFormCancellazione = useForm<StateFormCancellazione>({
    defaultValues: {
      daPagare: false,
      sospeso: false,
      noteCancellazione: "",
    },
  });

  const onSubmitFormCancellazione = (data: StateFormCancellazione) => {
    setAppointmentToDelete((prev) => ({
      ...prev,
      daPagare: data.daPagare ? "S" : "",
      sospeso: data.sospeso ? "1" : "",
      noteAppuntamento: data.noteCancellazione,
    }));
    setShowModaleAnnullamentoLogico(false);
    setShowAllertDelete(true);
  };

  const headlines = [
    "Data Visita",
    "Ora",
    "Medico",
    "Durata",
    "Stato",
    "Azioni",
  ];

  const { control, handleSubmit, reset, setValue, getValues } =
    useForm<CommonFieldsData>({
      defaultValues: {
        numPrenotazione: "",
        idPaziente: "",
        cfPaziente: "",
        nominativo: "",
        dataNasPaziente: "",
        dataIni: "",
        dataFin: "",
        medico: "",
        specialita: "",
        impegnativa: "",
        codSISS: "",
        tipoApp: "A",
        tipoDate: "",
        ricercaId: "",
        origine: "tutte",
        tipoCodSISS: "",
      },
    });

  const formValues = useWatch<CommonFieldsData>({ control });

  //Stato per gestire le abilitazioni concesse all'operatore dall'api parPacaric
  // 1. Elenco chiavi permessi
  const PERM_KEYS = [
    "abilitaCancellazione",
    "abilitaInserimento",
    "abilitaModifica",
    "abilitaOrigineEclaim",
    "abilitaOrigineFlussoMTA",
    "abilitaOrigineG2",
    "abilitaOrigineGP",
    "abilitaSospensione",
    "abilitaSpostamento",
    "visualizzaCodiceSISS",
  ] as const;

  type PermissionKey = (typeof PERM_KEYS)[number];
  type Permissions = Record<PermissionKey, string>;

  // 2. Stato iniziale
  const defaultPermissions: Permissions = PERM_KEYS.reduce((acc, k) => {
    acc[k] = "0";
    return acc;
  }, {} as Permissions);

  const [permissions, setPermissions] =
    useState<Permissions>(defaultPermissions);
  const [paramsParpacaric, setParamsParpacaric] = useState<any>(null);

  //Stati per gestire le liste delle specialità e delle prestazioni
  const [specialitiesList, setSpecialitiesList] = useState<Specialty[]>([]);
  const [performancesList, setPerformancesList] = useState<Performance[]>([]);
  const [entiList, setEntiList] = useState<Enti[]>([]);

  //Stato per gestire la visalizzazione delle aziende
  const [showCompanies, setShowCompanies] = useState<string>();

  // 3. Login seguite da fetch parPacaric e aggiornamento dei permessi
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Con AuthGuard, l'utente e' gia' autenticato
        const permResponse = await parPacaric();
        const dataResponse = permResponse.data?.abilitazioni?.[0] ?? {};

        setParamsParpacaric(permResponse.data?.parametri?.[0]);
        setShowCompanies(permResponse.data?.visAziende);

        const next = PERM_KEYS.reduce((acc, k) => {
          acc[k] = dataResponse[k] ?? "0";
          return acc;
        }, {} as Permissions);

        setPermissions(next);

        permResponse.data.parametri.map(
          (param: {
            dataInizio: string;
            dataFine: string;
            codiceSISSDefault: string;
            dataDefault: string;
          }) => {
            setValue("dataIni", param.dataInizio);
            setValue("dataFin", param.dataFine);
            setValue("tipoCodSISS", param.codiceSISSDefault);

            setValue("tipoDate", param.dataDefault === "Visita" ? "V" : "P");

            // console.log({ formValues });
            return param;
          }
        );
      } catch (err) {
        console.error("Errore nel flusso login + permessi:", err);
      } finally {
        setLoadingData(false);
      }
    };

    fetchData();
  }, []);

  //UseEffect per il fetch delle specialità e delle prestazioni
  useEffect(() => {
    const fetchSpecialitaList = async () => {
      try {
        const payload = {
          tipoAgenda: "ALL",
          listino: "",
          medico: [],
          specialita: "",
          prestazione: "",
        };
        const response = await specialities(payload);
        // console.log("Specialità disponibili:", response.data);
        setSpecialitiesList(response.data.dati ?? []);
      } catch (error) {
        console.error("Errore nel fetch delle specialità:", error);
      }
    };

    const fetchPrestazioniList = async () => {
      try {
        const payload = {
          tipoAgenda: "ALL",
          listino: "",
          medico: [],
          specialita: "",
        };
        const response = await performance(payload);
        // console.log("Prestazioni disponibili:", response.data);
        setPerformancesList(response.data.dati);
      } catch (error) {
        console.error("Errore nel fetch delle prestazioni:", error);
      }
    };

    const fetchEntiList = async () => {
      const objectJsonRequest: CommonFieldsData = {
        tabella: "ENTI",
        codice: "",
        filtro: "",
        applicazione: "",
        attivi: "1",
      };

      try {
        const objectJsonResponse = await generalResearch(objectJsonRequest);
        const dataEnti = objectJsonResponse.data.dati.map(
          (e: Enti, index: number) => ({
            ...e,
            indice: index,
          })
        );

        const dataPosizioneTicketsToSort: Enti[] = dataEnti;

        const sortedEnti = dataPosizioneTicketsToSort.sort((a, b) => {
          if (a["ragione sociale"] > b["ragione sociale"]) {
            return 1;
          }
          if (b["ragione sociale"] > a["ragione sociale"]) {
            return -1;
          }
          return 0;
        });

        // console.log({ sortedEnti });
        setEntiList(sortedEnti);
      } catch (error) {
        console.error("Errore nella fetch di ricerca degli enti", error);
        return [];
      }
    };
    fetchSpecialitaList();
    fetchPrestazioniList();
    fetchEntiList();
  }, []);

  // Location per ricezione dei dati in caso di redirect dopo la conferma dell'Appuntamento in management
  const location = useLocation();
  const appointmentNumberToSubmitAfterEdit: string =
    location.state?.numeroAppuntamento || undefined;

  // useEffect che richiama evento submit in caso di redirect di modifica conclusa
  useEffect(() => {
    if (appointmentNumberToSubmitAfterEdit) {
      setValue("numPrenotazione", appointmentNumberToSubmitAfterEdit);
      handleSubmit(onSubmit)();
    }
  }, []);

  // Funzione navigate per passare da una pagina ad un'altra
  const navigate = useNavigate();

  // Funzione per il passaggio dati dell'appuntamento da modificare
  const appointmentManagementRedirect = async (
    appointmentData: AppointmentData,
    appointmentsList: AppointmentsByPACAPRE
  ) => {
    navigate("/gestione", { state: { appointmentData, appointmentsList } });
  };

  // State di controllo generico
  const [isValid, setIsValid] = useState(false);
  const [fieldsUncomplete, set_Are_Field_Uncomplete] = useState(false);

  // States di controllo campo numero prenotazione
  const [is_numPren_Valid, set_Is_numPren_Valid] = useState(true);
  const [is_numPren_Middle, set_Is_numPren_Middle] = useState(false);
  const [message_numPren_Message, set_numPren_Message] = useState("");

  // States di controllo campo codice fiscale
  const [is_codFisc_Valid, set_Is_codFisc_Valid] = useState(true);
  const [is_codFisc_Middle, set_Is_codFisc_Middle] = useState(false);
  const [message_coFisc_Message, set_codFisc_Message] = useState("");

  const [showAllertDelete, setShowAllertDelete] = useState(false);
  const [showAllertEdit, setShowAllertEdit] = useState(false);

  const [appointmentToDelete, setAppointmentToDelete] =
    useState<CommonFieldsData>({});

  const [appointmentToEdit, setAppointmentToEdit] = useState<AppointmentData>(); //Stato per gestire l'appuntamento da modificare
  const [appointmentsList, setAppointmentsList] =
    useState<AppointmentsByPACAPRE>();

  // States per gestire la fase di modifica di una prestazione
  const [editOpen, setEditOpen] = useState(false); //Apertura e chiusura della dialog
  const [editRow, setEditRow] = useState<any | null>(null); //La riga selezionata
  const [dataPrestazioneToEdit, setDataPrestazioneToEdit] =
    useState<DataPrestazioneToEdit | null>(null); //I dati della prestazione selezionata
  const [idPacaprSelected, setIdPacaprSelected] = useState<string>(""); //ID PACAPR della prestazione selezionata

  //Stato per gestire la visualizzazione del dettaglio dell'appuntamento
  const [dettaglioOpen, setDettaglioOpen] = useState<boolean>(false);

  //Stato per gestire la visualizzazione del dettaglio dell'appuntamento annullato
  const [dettaglioAnnullataOpen, setDettaglioAnnullataOpen] =
    useState<boolean>(false);

  // handler per il click su "Modifica"
  const onEditPrestazioneClick = async (row: any) => {
    try {
      const payload = {
        idPacapr: row.id,
        crud: "R",
        AZIENDAPRENOTAZIONE: riferimentiIDs?.azienda,
      };
      const response = await datiPacapr(payload);
      setIdPacaprSelected(row.id);
      // console.log("Riga selezionata per modifica:", row.id);

      // console.log("Response datiPacapr completa:", response.data);
      // console.log("Response datiPacapr dati prestazione:", response.data.dati);

      const prest = response?.data?.dati?.prestazione?.[0] as
        | DataPrestazioneToEdit
        | undefined;
      setDataPrestazioneToEdit(prest ?? null);
      setPosTicket(response.data.ricerche.postic ?? []);
      setRicRipe(response.data.ricerche.ricripe ?? []);
    } catch (error) {
      console.error("Errore nel fetch dei dati della prestazione:", error);
    } finally {
      setEditRow(row);
      setEditOpen(true);
    }
  };

  //Handler per la cancellazione della prestazione
  const handleDeletePrestazione = async (row: any) => {
    try {
      const payload = {
        idPacapr: row.id,
        crud: "D",
        AZIENDAPRENOTAZIONE: riferimentiIDs?.azienda,
      };
      // const response =
      await datiPacapr(payload);
      // console.log("Response datiPacapr cancellazione:", response);
    } catch (error) {
      console.error("Errore nella cancellazione della prestazione:", error);
    }
  };

  // Controllo se alcuni campi da compilare siano in sospeso
  useEffect(() => {
    if (is_numPren_Middle || is_codFisc_Middle) {
      set_Are_Field_Uncomplete(true);
    } else {
      set_Are_Field_Uncomplete(false);
    }
  }, [is_numPren_Middle, is_codFisc_Middle]);

  // Verifico se almeno uno dei campi stringa è riempito o se entrambe le date sono riempite
  useEffect(() => {
    const hasAtLeastOneFieldFilled =
      (formValues.dataIni && formValues.dataFin && formValues.nominativo) ||
      (formValues.dataIni &&
        formValues.nominativo &&
        formValues.dataNasPaziente) ||
      (formValues.nominativo && formValues.dataNasPaziente) ||
      formValues.dataIni;

    setIsDisabled(!hasAtLeastOneFieldFilled || fieldsUncomplete || !isValid);
  }, [fieldsUncomplete, formValues, isValid]);

  // Controllo sulla digitazione del field del numero prenotazione
  useEffect(() => {
    controlFunction(
      SOLO_NUMS_REGEX,
      formValues.numPrenotazione,
      set_Is_numPren_Middle,
      set_Is_numPren_Valid,
      "Sono richiesti solo caratteri numerici",
      "Contiene troppi caratteri",
      set_numPren_Message,
      [12]
    );

    is_numPren_Valid ? setIsValid(true) : setIsValid(false);
  }, [formValues.numPrenotazione]);

  // Controllo sulla digitazione del field del codice Fiscale
  useEffect(() => {
    controlFunction(
      ALPHA_NUMERIC_REGEX,
      formValues.cfPaziente,
      set_Is_codFisc_Middle,
      set_Is_codFisc_Valid,
      "Sono richiesti solo caratteri alfanumerici",
      "Contiene troppi caratteri",
      set_codFisc_Message,
      // aggiunto anche lunghezza per cf giuridico
      [11, 16]
    );

    is_codFisc_Valid ? setIsValid(true) : setIsValid(false);
  }, [formValues.cfPaziente]);

  // submit per avviare la ricerca degli appuntamenti recuperati sulla prima form della pagina
  const onSubmit = async (data: CommonFieldsData) => {
    setHasSearched(true);
    setAccordion(!accordion);

    const modifiedData = {
      ...data,
    };

    try {
      setLoadingData(true);
      const response = await appointmentResearchNew(modifiedData);

      if (response.data && typeof response.data.dati === "object") {
        const dati = response.data.dati;
        // console.log("dati ricevuti dall'api " + JSON.stringify(dati));
        // console.log("dati ricevuti dall'api ", dati);

        // Filtro gli appuntamenti, ignorando listaMedici e listaSpecialita
        const appointments = Object.keys(dati)
          .filter(
            (key) =>
              key !== "agendeAperte" &&
              key !== "listaMedici" &&
              key !== "listaSpecialita" &&
              key !== "parametriTabellone" &&
              key !== "indisponibilita"
          )
          .reduce((acc, key) => {
            const appointment = dati[key];
            //Se listaMedici e listaSpecialita non sono dentro appointment allora inserisco tutto in appointment
            if (
              appointment &&
              Object.keys(appointment).length > 0 &&
              !Object.keys(appointment).includes("listaMedici") &&
              !Object.keys(appointment).includes("listaSpecialita")
            ) {
              acc.push(appointment);
            }

            return acc;
          }, [] as any[]);

        // Imposta lo stato solo se ci sono appuntamenti validi
        if (appointments.length > 0) {
          const appointmentsToFilter: AppointmentData[] = appointments.flatMap(
            (a) => a
          );
          setAppointmentData(appointmentsToFilter);
          // console.log("Appuntamenti filtrati:", appointmentsToFilter);

          let appointmentsFormatted: AppoinmentsByPRENOTAZIONE[] = [];

          valorizeGroupedAppointments(
            appointmentsFormatted,
            appointmentsToFilter
          );

          // console.log("PER PRENOTAZIONE", appointmentsFormatted);

          setGroupedAppointmentData(appointmentsFormatted);
        } else {
          // console.log("Nessuna prenotazione trovata");
          setAppointmentData([]); // Reset completo degli array di appuntamenti
          setGroupedAppointmentData([]);
        }
      } else {
        console.error(
          "Errore: `response.data.dati` non è un oggetto valido o mancante"
        );
        setAppointmentData([]); // Resetta l'array in caso di errore
      }
    } catch (error) {
      console.error("Errore nella ricerca della prenotazione:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleResetForm = () => {
    reset({
      dataIni: dayjs(paramsParpacaric.dataInizio).format("YYYY-MM-DD"),
      dataFin: dayjs(paramsParpacaric.dataFine).format("YYYY-MM-DD"),
    });
    setAppointmentData([]);
    setGroupedAppointmentData([]);
    setHasSearched(false);
  };

  // Inserire lo state expanded per l'accordion dei cicli o singoli risultati contenuti in una PRENOTAZIONE
  const [expanded, setExpanded] = useState("");
  const [expandPrenotazione, setExpandPrenotazione] = useState<
    string | undefined
  >();

  // Metodo per gestire il click sulla accordion di interesse
  const handleAccordionToShow = (composedStringID: string) => {
    if (composedStringID === expanded) {
      setExpanded("");
    } else {
      setExpanded(composedStringID);
    }
  };

  // Metodo per gestire il click sulla accordion di interesse
  const handlePrenotazioneToShow = (NUMERO_PRENOTAZIONE: string) => {
    setExpandPrenotazione((prevState) =>
      prevState === NUMERO_PRENOTAZIONE ? undefined : NUMERO_PRENOTAZIONE
    );
    setExpanded("");
  };

  // Metodo richiamato dall'evento al click del pulsante pdf per la stampa del documento
  const assignedAppointmentToPrint = async (numeroPrenotazione: string) => {
    try {
      const response = await printPDF({ numPren: numeroPrenotazione });

      if (response.data.esito !== "OK" || !response.data.risposta.pdfBase64) {
        throw new Error("Errore nella generazione del PDF");
      }

      // Decodifica il Base64 in un array di byte
      const byteCharacters = atob(response.data.risposta.pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Crea un Blob con il tipo MIME PDF
      const blob = new Blob([byteArray], { type: "application/pdf" });

      // Crea un link per il download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `prenotazione_${numeroPrenotazione}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Pulizia dell'elemento
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Errore nel download del PDF:", error);
    }
  };

  // Creazione dell'oggetto con id PACADA da inviare per eseguire eventuale conferma di una Delete
  const assignedAppointmentToDelete = (
    idPacate: number | undefined,
    idPacapr?: number | undefined,
    idPacada?: number | undefined
  ) => {
    const temp: CommonFieldsData = {
      // keyStatus: "4", conferma eliminazione e valorizzazione del campo di STATO_PRENOTAZIONE a cancellato
      keyStatus: "4",

      idPaziente: "",
      medico: "",
      data: "",
      orari: "",
      durata: "",
      prestazione: "",
      specialita: "",
      tipoAgenda: "",
      agenda: "",
      importo: "",
      codiceOperatore: "",
      cognomePaziente: "",
      nomePaziente: "",
      primaDisponibilita: "",
      telefonoPaziente: "",

      idPacate: idPacate ?? 0,
      idPacapr: idPacapr ?? 0,
      idPacada: idPacada ?? 0,

      aziendaPrenotazione: "",
      sospeso: "",
      daPagare: "",
    };

    setAppointmentToDelete(temp);
    // console.log("Eliminerei", temp);
  };

  // NOTA: inutilizzata al momento da implementaria previa richiesta conferma di modifica
  const assignedAppointmentToEdit = (
    appointmentData: AppointmentData,
    appointmentsList: AppointmentsByPACAPRE
  ) => {
    setAppointmentsList(appointmentsList);
    setAppointmentToEdit(appointmentData);
    // console.log("Modificherei", appointmentData);
  };

  // Invio request di cancellazione dell'appuntamento dichiarato in fase di selezione della cancellazione
  const handleDeleteConfirmation = async () => {
    setShowAllertDelete(false);
    await manageAppointment(appointmentToDelete).catch((error) => {
      console.error("Errore durante cancellazione appuntamento:", error);
    });
    setHasSearched(false);
    setAppointmentData([]);
    setGroupedAppointmentData([]);
    methodsFormCancellazione.reset();

    onSubmit(formValues);
  };

  const handleEditConfirmation = (
    appointmenToEdit: AppointmentData,
    appointmentsList: AppointmentsByPACAPRE
  ) => {
    setShowAllertEdit(false);
    appointmentManagementRedirect(appointmenToEdit, appointmentsList);
  };

  // mock/fallback; sostituisci con i tuoi dati reali
  const entiOptions = [
    "AMBRO1",
    "BREBBIA",
    "CLINIQUE63",
    "COQ",
    "MEDITEL",
    "MAXTAC",
  ];

  const radioRowSx = { "& .MuiFormControlLabel-root": { mr: 3 } };

  const listPaperSx = {
    maxHeight: 200,
    overflowY: "auto",
    border: "2px solid #E2E6EA",
    borderRadius: 1,
    boxShadow: "none",
    // scrollbar “thin”
    "&::-webkit-scrollbar": { width: 8 },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#C7D0D9",
      borderRadius: 8,
    },
  };

  const listItemSx = {
    px: 1,
    height: 40,
    "& .MuiListItemText-primary": { fontSize: 14, color: "text.primary" },
    "&.Mui-selected": { bgcolor: "#E6F2FC" },
    "&.Mui-selected:hover": { bgcolor: "#E6F2FC" },
  };

  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [prestazioniDetails, setPrestazioniDetails] = useState<any[]>([]);
  const [tabRuoli, setTabRuoli] = useState<TabRuoli[]>();
  const [posTicket, setPosTicket] = useState<PosTick[]>();
  const [ricRipe, setRicRipe] = useState<RicRipe[]>();
  const [prenotazioneDetails, setPrenotazioneDetails] = useState<any>();
  const [selectedAppointmentIDPACAPR, setSelectedAppointmentIDPACAPR] =
    useState<string>();
  const [appuntamentiDetails, setAppuntamentiDetails] = useState<any>([]);
  const [appuntamentiAnnullatiDetails, setAppuntamentiAnnullatiDetails] =
    useState<any>([]);
  const [dataSelectedAppointment, setDataSelectedAppointment] =
    useState<PacadaPayload>();
  const [completoPaziente, setCompletoPaziente] = useState<CompletoPaziente>({
    id: "",
    nome: "",
    cognome: "",
    dataNascita: "",
  });
  const [riferimentiIDs, setRiferimentiIDs] =
    useState<RiferimentiIDsIstanzaPrenotazione>();
  const [showAppointmentDetail, setShowAppointmentDetail] =
    useState<boolean>(false);
  const [showModaleAnnullamentoLogico, setShowModaleAnnullamentoLogico] =
    useState<boolean>(false);
  const [priorityText, setPriorityText] = useState("");
  const maxPriorityLength = 400;

  const methodsDettaglioPrenotazione =
    useForm<AppointmentResearchDettaglioPrenotazione>({
      defaultValues: {
        numeroPrenotazione: "",
        dataPrenotazione: "",
        idPrenotazione: "",
        totPrenotazione: "",
        paziente: "",
        dataDiNascita: "",
        sesso: "",
        telefono: "",
        praticaRicovero: "",
        origine: {
          sysClinique: "",
          gp: "",
          g2: "",
          tuoTempo: "",
          web: "",
          flussoMta: "",
          eclaim: "",
        },
        notePrenotazione: "",
        ruoloOperatore: "",
        aslPrenotazione: "",
        temporaneo: false,
      },
    });

  const values = methodsDettaglioPrenotazione.watch();
  const watchNumeroPrenotazione =
    methodsDettaglioPrenotazione.watch("numeroPrenotazione");
  const watchDataPrenotazione =
    methodsDettaglioPrenotazione.watch("dataPrenotazione");
  const watchIdPaziente = methodsDettaglioPrenotazione.watch("idPaziente");
  const watchIdPrenotazione =
    methodsDettaglioPrenotazione.watch("idPrenotazione");
  const watchTotPrenotazione =
    methodsDettaglioPrenotazione.watch("totPrenotazione");
  const watchPaziente = methodsDettaglioPrenotazione.watch("paziente");
  const watchDataDiNascita =
    methodsDettaglioPrenotazione.watch("dataDiNascita");
  const watchSesso = methodsDettaglioPrenotazione.watch("sesso");
  const watchTelefono = methodsDettaglioPrenotazione.watch("telefono");
  const watchPraticaRicovero =
    methodsDettaglioPrenotazione.watch("praticaRicovero");

  // Origine → puoi fare watch di tutto l’oggetto o dei singoli campi
  const watchOrigine = methodsDettaglioPrenotazione.watch("origine");
  const watchNotePrenotazione =
    methodsDettaglioPrenotazione.watch("notePrenotazione");
  const watchRuoloOperatore =
    methodsDettaglioPrenotazione.watch("ruoloOperatore");
  const watchAslPrenotazione =
    methodsDettaglioPrenotazione.watch("aslPrenotazione");
  const watchTemporaneo = methodsDettaglioPrenotazione.watch("temporaneo");

  const sendPaylodUpdateDettaglioPrenotazione = async () => {
    try {
      const response = await datiPrenotazione({
        numPrenotazione: watchNumeroPrenotazione,
        crud: "U",
        DATAPREN: watchDataPrenotazione,
        IDSKENOS: "0",
        IDPAZIENTE: completoPaziente.id,
        COGNOMEPAZIENTE: completoPaziente.cognome,
        NOMEPAZIENTE: completoPaziente.nome,
        TELEFONOPAZIENTE: watchTelefono,
        DATANASPAZIENTE: completoPaziente.dataNascita,
        LIBRETTOPAZIENTE: "",
        CODCOMRESPAZIENTE: "",
        NUMTESSERA: "",
        SESSOPAZIENTE: watchSesso,
        SWPAZDISABILE: "0",
        CODSPORT: "",
        ORIGINE: watchOrigine,
        PACATESWTEMP: watchTemporaneo === true ? "T" : "D",
        RILPAZIENTE: "0",
        NOTEPRENOTAZIONE: watchNotePrenotazione,
        CODMEDBAS: "",
        IDMEDBAS: "0",
        RUOLOOPERATORE: watchRuoloOperatore,
        AZIENDAPRENOTAZIONE: riferimentiIDs?.azienda,
      });

      // console.log("RESPONSE UPDATE PRESTAZIONE", response);

      if (response.data.esito === "OK") {
        setSeverity("success");
      } else {
        setSeverity("error");
      }
      setMessage(response.data.messaggio);
    } catch (error) {
      console.error(error);
    }
  };

  // funzione per mappare i dati in ingresso da mostrare sulla griglia del dettaglio di prenotazione
  const mappedDettaglioPrestazioniToShow = (data: any) => {
    const mapped = data.flatMap((item: any) => ({
      id: item.IDPACAPR ?? "",
      Specialita: item.DESSPECIA,
      Prestazione: item.DESANAPRE,
      Distretto: item.DISTRETTO || item.DISTRETTO !== "" ? item.DISTRETTO : "",
      Importo: item.IMPORTO || item.IMPORTO !== "" ? item.IMPORTO : "",
    }));
    setShowAppointmentDetail(true);
    setPrestazioniDetails(mapped);
  };

  // funzione per mappare gli appuntamenti in ingresso e i relativi dettagli
  const mappedDettaglioAppuntamentiToShowNew = (data: any) => {
    const mapped = data?.flatMap((e: any) =>
      e?.appuntamenti
        ? e.appuntamenti.map((item: any) => ({
            id: item.IDPACADA ?? item.IDPACADC ?? "",
            codMedInt: item.CODMEDINT ?? item.CODMEDINT ?? "",
            dtPrestazione:
              item.DATAVISITA || item.DATAVISITA !== "" ? item.DATAVISITA : "",
            idPacaPre: e.IDPACAPR || e.IDPACAPR !== "" ? e.IDPACAPR : "",
            ora: item.ORAVISITA || item.ORAVISITA !== "" ? item.ORAVISITA : "",
            durata: item.DURATA || item.DURATA !== "" ? item.DURATA : "",
            medico:
              item.NOMINMEDINT || item.NOMINMEDINT !== ""
                ? item.NOMINMEDINT
                : "",
            accettato: item.IDACCETTAZIONE,
            usufruito: item.USUFRUITO,
            impegnativa:
              item.IMPEGNATIVA || item.IMPEGNATIVA !== ""
                ? item.IMPEGNATIVA
                : "",
            assenza: item.ASSENZA,
          }))
        : []
    );
    const mappedAnnullati = data?.flatMap((e: any) =>
      e?.appAnnullati
        ? e.appAnnullati.map((item: any) => ({
            idPacaDc: item.IDPACADC ?? "",
            codMedInt: item.CODMEDINT ?? "",
            codTpgPre: item.CODTPGPRE ?? "",
            descrTpgPre: item.DESTPGPRE ?? "",
            dataVisita: item.DATAVISITA || "",
            idPacaPre: e.IDPACAPR || "",
            ora: item.ORAVISITA || "",
            durata: item.DURATA || "",
            medico: item.NOMINMEDINT || "",
            accettato: item.IDACCETTAZIONE,
            usufruito: item.USUFRUITO,
            assenza: item.ASSENZA,
            stato: item.STATO ?? "",
          }))
        : []
    );
    // console.log("Appuntamenti attivi", mapped);
    // console.log("Appuntamenti annullati", mappedAnnullati);

    setAppuntamentiDetails(mapped);
    setAppuntamentiAnnullatiDetails(mappedAnnullati);
  };

  // funzione per l'evento di cancellazione di un'appuntamento già cancellato da Storico annullamenti
  const handleCancellazioneFisicaAppuntamentoCancellato = async (
    appuntamento: any
  ) => {
    try {
      const payload = {
        idPacadc: appuntamento.idPacaDc,
        crud: "D",
        CODMEDINT: appuntamento.codMedInt,
        aziendaPrenotazione: riferimentiIDs?.azienda,
      };
      // const response =
      await datiPacadc(payload);
      // console.log("Response datiPacadc cancellazione:", response);
    } catch (error) {
      console.error(
        "Errore nella cancellazione fisica dell'appuntamento':",
        error
      );
    }
  };

  // funzione per l'evento di cancellazione di un'appuntamento presente dalla lista recuperata di una prenotazione
  const handleCancellazioneFisicaAppuntamento = async (appuntamento: any) => {
    try {
      const payload = {
        idPacada: appuntamento.id,
        crud: "D",
        CODMEDINT: appuntamento.codMedInt,
        aziendaPrenotazione: riferimentiIDs?.azienda,
      };
      // const response =
      await datiPacada(payload);
      // console.log("Response datiPacada cancellazione logica:", response);
    } catch (error) {
      console.error(
        "Errore nella cancellazione logica dell'appuntamento':",
        error
      );
    }
  };

  // funzione per mappare i dati in ingresso da mostrare sul form del dettaglio della prenotazione
  const mappedDettaglioPrenotazioneToShow = (data: any) => {
    const mapped = {
      numeroPrenotazione: data.NUMPREN,
      dataPrenotazione: data.DATAPREN,
      idPrenotazione: data.IDPACATE,
      totPrenotazione: data.NUMTOTPRESTAZIONI,
      paziente: data.COGNOMEPAZIENTE.concat(" ", data.NOMEPAZIENTE),
      dataDiNascita: data.DATANASPAZIENTE,
      sesso: data.SESSOPAZIENTE,
      telefono: data.TELEFONOPAZIENTE,
      praticaRicovero: "",
      notePrenotazione: data.NOTEPRENOTAZIONE,
      ruoloOperatore: data.RUOLOOPERATORE,
      aslPrenotazione: data.ASLPRENOTAZIONE,
      temporaneo: data.PACATESWTEMP === "D" ? false : true,
      origine: data.ORIGINE,
    };
    setCompletoPaziente({
      nome: data?.NOMEPAZIENTE,
      cognome: data?.COGNOMEPAZIENTE,
      id: data?.IDPAZIENTE,
      dataNascita: data?.DATANASPAZIENTE,
    });
    setPrenotazioneDetails(mapped);
  };

  const fetchPrenotazioneDettaglio = async (
    numeroPrenotazione: string,
    aziendaPrenotazione: string
  ) => {
    try {
      setLoadingData(true);
      const response = await datiPrenotazione({
        numPrenotazione: numeroPrenotazione,
        aziendaPrenotazione: aziendaPrenotazione,
        crud: "R",
      });

      // console.log("Dettaglio ", response.data.dati);
      setTabRuoli(response.data.ricerche.tabruoli);

      mappedDettaglioPrestazioniToShow(
        response.data.dati.prestazioni.prestazione
      );
      mappedDettaglioPrenotazioneToShow(response.data.dati.prenotazione[0]);
      mappedDettaglioAppuntamentiToShowNew(
        response.data.dati.prestazioni.prestazione
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingData(false);
      setShowAppointmentDetail(true);
    }
  };

  const fetchAppuntamentoDettaglio = async (
    numeroAppuntamento: string,
    aziendaPrenotazione: string,
    codiceMedicoInterno: string
  ) => {
    try {
      setLoadingData(true);
      const response = await datiPacada({
        idPacada: numeroAppuntamento,
        aziendaPrenotazione: aziendaPrenotazione,
        crud: "R",
        CODMEDINT: codiceMedicoInterno,
      });
      // console.log("Dettaglio appuntamento", response.data.dati.appuntamento);
      setDataSelectedAppointment({
        ...response.data.dati.appuntamento[0],
        idPacada: numeroAppuntamento,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingData(false);
    }
  };

  const fetchRipristinoAppuntamentoCancellato = async (
    numeroAppuntamento: string,
    aziendaPrenotazione: string
  ) => {
    try {
      // const response =
      await ripriPacadc({
        idPacadc: numeroAppuntamento,
        aziendaPrenotazione: aziendaPrenotazione,
      });
      // console.log("Risposta", response);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAppuntamentoCancellatoDettaglio = async (
    numeroAppuntamento: string,
    aziendaPrenotazione: string,
    codiceMedicoInterno: string
  ) => {
    try {
      const response = await datiPacadc({
        idPacadc: numeroAppuntamento,
        aziendaPrenotazione: aziendaPrenotazione,
        crud: "R",
        CODMEDINT: codiceMedicoInterno,
      });
      // console.log(
      //   "Dettaglio appuntamento",
      //   response.data.dati.appuntamentoAnnullato
      // );
      setDataSelectedAppointment({
        ...response.data.dati.appuntamentoAnnullato[0],
        idPacadc: numeroAppuntamento,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setDettaglioAnnullataOpen(true);
      // console.log({ dataSelectedAppointment });
    }
  };

  // useEffect di valorizzazione dei field per la form modale del dettaglio della Prenotazione
  useEffect(() => {
    if (!prenotazioneDetails) return;

    // console.log({ prenotazioneDetails });

    const initialValues: AppointmentResearchDettaglioPrenotazione = {
      numeroPrenotazione: prenotazioneDetails.numeroPrenotazione ?? "",
      dataPrenotazione: prenotazioneDetails.dataPrenotazione ?? "",
      idPrenotazione: "",
      totPrenotazione: prenotazioneDetails.totPrenotazione ?? "",
      paziente: prenotazioneDetails.paziente ?? "",
      dataDiNascita: prenotazioneDetails.dataDiNascita ?? "",
      sesso: prenotazioneDetails.sesso ?? "",
      telefono: prenotazioneDetails.telefono ?? "",
      praticaRicovero: prenotazioneDetails.praticaRicovero ?? "",
      origine: prenotazioneDetails.origine,
      notePrenotazione: prenotazioneDetails.notePrenotazione ?? "",
      ruoloOperatore: prenotazioneDetails.ruoloOperatore ?? "",
      aslPrenotazione: prenotazioneDetails.aslPrenotazione ?? "",
      idPaziente: prenotazioneDetails.idPaziente ?? "",
      temporaneo: prenotazioneDetails.temporaneo ?? false,
    };

    methodsDettaglioPrenotazione.reset(initialValues);
  }, [prenotazioneDetails, methodsDettaglioPrenotazione]);

  const columnsTablePrestazioni: GridColDef[] = [
    { field: "Specialita", headerName: "Specialità", flex: 3, editable: false },
    {
      field: "Prestazione",
      headerName: "Prestazione",
      flex: 3,
      editable: false,
    },
    {
      field: "Distretto",
      headerName: "Distretto",
      flex: 2,
      editable: false,
      valueGetter: (params) => {
        let value = params.row.Distretto || "";

        value = value.trimEnd();

        value = value.replace(/PROVA/g, "");

        return value;
      },
    },
    {
      field: "Importo",
      headerName: "Importo",
      flex: 1,
      editable: false,
      renderCell: (params) => `${params.row.Importo} €`,
    },
    {
      field: "actions",
      headerName: "Azioni",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          <Tooltip title={"Modifica"}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onEditPrestazioneClick(params.row);
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  height: {
                    md: 20,
                  },
                  width: {
                    md: 20,
                  },
                }}
                image={blackPencil}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Cancella"}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                askConfirmDelete(params.row);
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  height: {
                    md: 20,
                  },
                  width: {
                    md: 20,
                  },
                }}
                image={redTrashBin}
              />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const columnsTableAppuntamenti: GridColDef[] = [
    {
      field: "dtPrestazione",
      headerName: "Dt. Visita",
      flex: 1,
      editable: false,
      renderCell: (params) =>
        dayjs(params.row.dtPrestazione).format(`DD/MM/YYYY`),
    },
    {
      field: "ora",
      headerName: "Ora",
      flex: 1,
      editable: false,
      renderCell: (params) => formatHour(params.row.ora),
    },
    {
      field: "durata",
      headerName: "Durata",
      flex: 1,
      editable: false,
      renderCell: (params) => `${params.row.durata}' `,
    },
    { field: "medico", headerName: "Medico", flex: 2, editable: false },
    {
      field: "impegnativa",
      headerName: "Impegnativa",
      flex: 1,
      editable: false,
    },
    {
      field: "usufruito",
      headerName: "Us.",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        if (params.row.usufruito !== "")
          return (
            <CardMedia
              component="img"
              className="icon-img"
              sx={{
                height: 20,
                width: 20,
              }}
              image={iconaSpuntaAppuntamento}
            />
          );
      },
    },
    {
      field: "accettato",
      headerName: "Acc.",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        if (params.row.accettato !== "0") {
          return (
            <CardMedia
              component="img"
              className="icon-img"
              sx={{
                height: 20,
                width: 20,
              }}
              image={iconaSpuntaAppuntamento}
            />
          );
        } else {
          return "";
        }
      },
    },
    {
      field: "assenza",
      headerName: "Ass.",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        if (params.row.assenza !== "")
          return (
            <CardMedia
              component="img"
              className="icon-img"
              sx={{
                height: 20,
                width: 20,
              }}
              image={iconaSpuntaAppuntamento}
            />
          );
      },
    },
    {
      field: "actions",
      headerName: "Azioni",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          <Tooltip title="Modifica">
            <IconButton
              onClick={async () => {
                try {
                  await fetchAppuntamentoDettaglio(
                    params.row.id ?? "",
                    riferimentiIDs?.azienda ?? "",
                    params.row.codMedInt ?? ""
                  );
                } catch (error) {
                  console.error("Errore evento fetch click");
                } finally {
                  setDettaglioOpen(true);
                }
              }}
            >
              <CardMedia
                component="img"
                sx={{ height: { md: 20 }, width: { md: 20 } }}
                image={blackPencil}
              />
            </IconButton>
          </Tooltip>

          <Tooltip title="Cancellazione fisica">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                askConfirmCancellazioneFisica(params.row);
              }}
            >
              <CardMedia
                component="img"
                sx={{ height: { md: 20 }, width: { md: 20 } }}
                image={redTrashBin}
              />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  //Cambia lo stato selectedTab da 0 a 1 in base alla Tab selezionata dall'utente
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  // Funzione per determinare lo stato di una prenotazione tra Attiva, Sospesa e Cancellata
  const getAppointmentState = (appt: AppoinmentsByPRENOTAZIONE) => {
    const stati = appt.GRUPPO_PRESTAZIONI.flatMap((p) =>
      p.GRUPPO_APPUNTAMENTI.map((a) => a.STATOPRENOTAZIONE)
    );
    if (stati.some((s) => s === "Attiva")) return "Attiva";
    if (stati.some((s) => s === "Sospesa")) return "Sospesa";
    return "Cancellata";
  };

  // Funzione per determinare il colore dello stato di una prenotazione tra Attiva, Sospesa e Cancellata
  const getStatusColor = (s: string): "success" | "warning" | "error" =>
    //Verde per Attiva, Arancione per Sospesa, Rosso per Cancellata
    s === "Attiva" ? "success" : s === "Sospesa" ? "warning" : "error";

  //UseForm per la gestione del modale delle prestazioni effettuate
  type EditForm = {
    specialita: string;
    prestazione: string;
    distretto: string;
    importo: string;
    posizioneTicket: string;
    ente: string;
    ripetizione: string;
    idEventoConfirmo: string;
    temporaneo: boolean;
  };

  const {
    control: editControl,
    reset: resetEdit,
    handleSubmit: handleEditSubmit,
    watch: editWatch,
    setValue: setEditValue,
  } = useForm<EditForm>({
    defaultValues: {
      specialita: "",
      prestazione: "",
      distretto: "",
      importo: "",
      posizioneTicket: "",
      ente: "",
      ripetizione: "",
      idEventoConfirmo: "",
      temporaneo: false,
    },
  });

  const fetchUpdatePrestazione = async (data: any) => {
    // console.log("Dati da inviare per l'update:", data);

    try {
      const payload = {
        idPacapr: idPacaprSelected,
        crud: "U",
        DATAPREN: dataPrestazioneToEdit?.DATAPRENOTAZIONE ?? "",
        CODSPECIA: data.specialita,
        CODANAPRE: data.prestazione,
        DISTRETTO: data.distretto,
        IMPORTO: data.importo,
        CODPOSTIC: data.posizioneTicket,
        CODENTI: data.ente,
        CODRIPETIZIONE: data.ripetizione,
        IDEVENTOCONFIRMO: data.idEventoConfirmo,
        PACAPRSWTEMP: data.temporaneo ? "T" : "D",
        AZIENDAPRENOTAZIONE: riferimentiIDs?.azienda,
      };
      const response = await datiPacapr(payload);
      // console.log("Response aggiornamento prestazione:", response.data);

      if (response.data.esito === "OK") {
        setSeverity("success");
        setMessage(
          response.data.messaggio || "Aggiornamento avvenuto con successo."
        );
      } else {
        setSeverity("error");
        setMessage(
          response.data.messaggio || "Errore durante l'aggiornamento."
        );
      }
    } catch (error) {
      console.error("Errore nell'aggiornamento della prestazione:", error);
      setEditOpen(false);
    } finally {
      setEditOpen(false);
      setHasSearched(false);
      setAppointmentData([]);
      setGroupedAppointmentData([]);
      onSubmit(formValues);
    }
  };

  const mapRowToEditForm = (row: any) => ({
    specialita:
      row.CODSPECIA ??
      row.SPECIALITA ??
      row.Specialita ??
      row.codSpecialita ??
      "",
    prestazione:
      row.CODANAPRE ??
      row.PRESTAZIONE ??
      row.Prestazione ??
      row.codPrestazione ??
      "",
    distretto: row.DISTRETTO ?? row.Distretto ?? row.distretto ?? "",
    importo: row.IMPORTO ?? row.Importo ?? row.importo ?? "",
    posizioneTicket:
      row.CODPOSTIC ?? row.POSIZIONETICKET ?? row.posizioneTicket ?? "",
    ente: row.CODENTI ?? row.ENTE ?? row.ente ?? "",
    ripetizione: row.CODRIPETIZIONE ?? row.RIPETIZIONE ?? row.ripetizione ?? "",
    idEventoConfirmo:
      row.IDEVENTOCONFIRMO ??
      row.ID_EVENTO_CONFIRMO ??
      row.idEventoConfirmo ??
      "",
    temporaneo:
      (row.PACAPRSWTEMP ?? row.TEMPORANEO ?? row.temporaneo) === "T" ||
      !!(row.TEMPORANEO ?? row.temporaneo),
  });

  //Quando si apre il modale di edit, se sono presenti i dati della prestazione da modificare o visualizzare,
  // valorizzo i campi del form
  useEffect(() => {
    if (editOpen && dataPrestazioneToEdit) {
      // resetEdit({
      //   specialita: dataPrestazioneToEdit.CODSPECIA ?? "",
      //   prestazione: dataPrestazioneToEdit.CODANAPRE ?? "",
      //   distretto: dataPrestazioneToEdit.DISTRETTO ?? "",
      //   importo: dataPrestazioneToEdit.IMPORTO ?? "",
      //   posizioneTicket: dataPrestazioneToEdit.CODPOSTIC ?? "",
      //   ente: dataPrestazioneToEdit.CODENTI ?? "",
      //   ripetizione: dataPrestazioneToEdit.CODRIPETIZIONE ?? "",
      //   idEventoConfirmo: dataPrestazioneToEdit.IDEVENTOCONFIRMO ?? "",
      //   temporaneo: dataPrestazioneToEdit.PACAPRSWTEMP === "D",
      // });
      resetEdit(mapRowToEditForm(dataPrestazioneToEdit), {
        keepDefaultValues: true,
        keepDirty: false,
        keepTouched: false,
      });
    }
  }, [editOpen, dataPrestazioneToEdit, resetEdit]);

  const getPerfSpecialita = (p: any) =>
    p?.SPECIALITA ?? p?.CODSPECIALITA ?? p?.CODSPEC ?? "";

  const selectedSpec = editWatch("specialita");
  const selectedPerf = editWatch("prestazione");

  // Filtro le prestazioni in base alla specialità selezionata
  // Se non c'è una specialità selezionata, mostra tutte le prestazioni
  // Se non ci sono prestazioni caricate, ritorna un array vuoto
  // useMemo per evitare ricalcoli ad ogni render
  const filteredPerformances = React.useMemo(() => {
    if (!performancesList) return [];
    if (!selectedSpec) return performancesList;
    return performancesList.filter(
      (p) => String(getPerfSpecialita(p)) === String(selectedSpec)
    );
  }, [performancesList, selectedSpec]);

  // useEffect per aggiornare il campo specialita quando viene selezionata una prestazione
  // e per resettare il campo prestazione quando viene selezionata una specialità
  useEffect(() => {
    if (!selectedPerf) return;
    const perf = performancesList?.find(
      (p) => String(p.PRESTAZIONE) === String(selectedPerf)
    );
    const spec = getPerfSpecialita(perf);
    if (spec && spec !== selectedSpec) {
      setEditValue("specialita", spec, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [selectedPerf, performancesList, selectedSpec, setEditValue]);

  // useEffect per resettare il campo prestazione se la prestazione selezionata
  // non è più valida per la specialità selezionata
  useEffect(() => {
    if (!selectedSpec || !selectedPerf) return;
    const stillValid = performancesList?.some(
      (p) =>
        String(p.PRESTAZIONE) === String(selectedPerf) &&
        String(getPerfSpecialita(p)) === String(selectedSpec)
    );
    if (!stillValid) {
      setEditValue("prestazione", "", {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [selectedSpec, selectedPerf, performancesList, setEditValue]);

  // Stati per la gestione dell'Allert di conferma azione (modifica o cancellazione)
  const [showAllert, setShowAllert] = useState(false);
  const [severity, setSeverity] = useState<"warning" | "success" | "error">(
    "warning"
  );
  const [message, setMessage] = useState("");

  // Stato per gestire il tipo di azione in sospeso (edit o delete) e i dati associati
  const [pendingAction, setPendingAction] = useState<null | {
    type:
      | "edit"
      | "delete"
      | "editPrenotazione"
      | "editAppuntamento"
      | "restoreAppointmentDeleted"
      | "deletePhisicalAppointment"
      | "deletePhisicalAppointmentDeleted";
    row?: any;
  }>(null);

  const askConfirmEditPrenotazione = () => {
    setPendingAction({ type: "editPrenotazione" });
    setMessage("Confermi la modifica della prenotazione?");
    setSeverity("warning");
    setShowAllert(true);
  };

  const askForRestoreAppointment = (row: any) => {
    setPendingAction({ type: "restoreAppointmentDeleted", row });
    setMessage("Confermi il ripristino del'appuntamento'?");
    setSeverity("warning");
    setShowAllert(true);
  };

  // Funzioni per chiedere conferma di azione (edit o delete)
  const askConfirmEdit = () => {
    setPendingAction({ type: "edit" });
    setMessage("Confermare la modifica della prestazione?");
    setSeverity("warning");
    setShowAllert(true);
  };

  const askConfirmDelete = (row: any) => {
    setPendingAction({ type: "delete", row });
    setMessage("Confermare la cancellazione della prestazione?");
    setSeverity("warning");
    setShowAllert(true);
  };

  const askConfirmCancellazioneFisica = (row: any) => {
    setPendingAction({ type: "deletePhisicalAppointment", row });
    setMessage(
      "Confermare la cancellazione fisica dell'appuntamento? (Non sarà recuperabile)"
    );
    setSeverity("warning");
    setShowAllert(true);
  };

  const askConfirmCancellazioneFisicaAppuntamentoCancellato = (row: any) => {
    setPendingAction({ type: "deletePhisicalAppointmentDeleted", row });
    setMessage(
      "Confermare la cancellazione dell'appuntamento annullato? (Non sarà recuperabile)"
    );
    setSeverity("warning");
    setShowAllert(true);
  };

  // Funzione eseguita alla conferma dell'Allert, che esegue l'azione in sospeso
  // e mostra il messaggio di esito
  const onAlertConfirm = async () => {
    setShowAllert(false);
    try {
      if (pendingAction?.type === "editPrenotazione") {
        await sendPaylodUpdateDettaglioPrenotazione();
        return;
      }

      if (pendingAction?.type === "edit") {
        await handleEditSubmit(fetchUpdatePrestazione)();
        return;
      }

      if (pendingAction?.type === "delete" && pendingAction.row) {
        await handleDeletePrestazione(pendingAction.row);
        setSeverity("success");
        setMessage("Prestazione cancellata.");
        return;
      }

      if (
        pendingAction?.type === "deletePhisicalAppointment" &&
        pendingAction.row
      ) {
        await handleCancellazioneFisicaAppuntamento(pendingAction.row);
        setSeverity("success");
        setMessage("Appuntamento cancellato.");
        return;
      }

      if (
        pendingAction?.type === "deletePhisicalAppointmentDeleted" &&
        pendingAction.row
      ) {
        await handleCancellazioneFisicaAppuntamentoCancellato(
          pendingAction.row
        );
        setSeverity("success");
        setMessage("Appuntamento cancellato.");
        return;
      }

      if (
        pendingAction?.type === "restoreAppointmentDeleted" &&
        pendingAction.row
      ) {
        await handleOnClickRipristinoAppuntamento(pendingAction.row);
        setSeverity("success");
        setMessage("Appuntamento ripristinato.");
        return;
      }
    } catch {
      setSeverity("error");
      setMessage("Si è verificato un errore.");
    } finally {
      setPendingAction(null);
      setShowAllert(true);
    }
  };

  // useEffect per chiudere automaticamente l'Allert dopo 4 secondi se non è di warning
  useEffect(() => {
    if (showAllert && severity !== "warning") {
      const allertAnimation = setTimeout(() => {
        setShowAllert(false);
      }, 4000);

      const allertState = setTimeout(() => {
        setSeverity("warning");
        setMessage("");
      }, 6000);

      return () => {
        clearTimeout(allertAnimation);
        clearTimeout(allertState);
      };
    }
  }, [showAllert, severity]);

  // useEffect per gestire il refresh ad una modifica/cancellazione interna al workflow della prenotazione
  useEffect(() => {
    if (
      !showAllert &&
      riferimentiIDs?.numPrenotazione &&
      riferimentiIDs?.azienda
    ) {
      fetchPrenotazioneDettaglio(
        riferimentiIDs.numPrenotazione,
        riferimentiIDs.azienda
      );
    }
  }, [showAllert, riferimentiIDs]);

  // fetch dell'appuntamento cancellato
  const handleOnClickDettaglioAppuntamento = (params: any) => {
    fetchAppuntamentoCancellatoDettaglio(
      params.idPacaDc ?? "",
      riferimentiIDs?.azienda ?? "",
      params.codMedInt ?? ""
    );
  };

  const handleOnClickRipristinoAppuntamento = async (params: any) => {
    try {
      fetchRipristinoAppuntamentoCancellato(
        params.idPacaDc ?? "",
        riferimentiIDs?.azienda ?? ""
      );
    } catch (error) {
      console.error(error);
    } finally {
      fetchPrenotazioneDettaglio(
        riferimentiIDs?.numPrenotazione ?? "",
        riferimentiIDs?.azienda ?? ""
      );
    }
  };

  // funzione per gestire l'uscita logica dal flow del dettaglio degli appuntamenti
  const handleOnClickUscita = () => {
    setShowAppointmentDetail(false);
    setSelectedAppointmentIDPACAPR("");
    handleSubmit(onSubmit)();
    setSelectedTab(0);
  };

  //Wrapper dati da passare a AppointmentDetailPanel
  const onEditClose = () => setEditOpen(false);
  const onEditAskConfirm = askConfirmEdit;

  const onRequestEditPrestazione = (row: any) => {
    // console.log("row per modale:", row);
    setDataPrestazioneToEdit(row);
    setEditOpen(true);
  };

  const [disabled, setDisabled] = useState<boolean>(true);

  useEffect(() => {
    if (
      getValues("origine") === "X" ||
      getValues("origine") === "ECLAIM" ||
      getValues("origine") === "MTA"
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
      setValue("ricercaId", "");
    }
  }, [getValues("origine")]);

  return (
    <Box>
      <Helmet>
        <title>Ricerca appuntamenti</title>
      </Helmet>
      {loadingData === null ? (
        <>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1300,
            }}
          >
            <CircularProgress size="6rem" />
          </Box>
        </>
      ) : (
        <>
          <AllertMessage
            showAllert={showAllert}
            setShowAllert={setShowAllert}
            severity={severity}
            message={message}
            submitFunction={onAlertConfirm}
          />
          {dettaglioOpen && (
            <AppointmentListDetail
              key={dataSelectedAppointment?.idPacada}
              onClose={() => setDettaglioOpen(false)}
              azienda={riferimentiIDs?.azienda}
              prenotazioneRequest={fetchPrenotazioneDettaglio}
              dataAppuntamento={dataSelectedAppointment}
            />
          )}
          {dettaglioAnnullataOpen && (
            <AppointmentDeletedListDetail
              onClose={() => setDettaglioAnnullataOpen(false)}
              azienda={riferimentiIDs?.azienda}
              prenotazioneRequest={fetchPrenotazioneDettaglio}
              dataAppuntamento={dataSelectedAppointment}
            />
          )}
          {showAppointmentDetail === true &&
            dettaglioOpen === false &&
            dettaglioAnnullataOpen === false && (
              <AppointmentDetailPanel
                onAskRestoreAppointment={askForRestoreAppointment}
                selectedPrestazioneId={selectedAppointmentIDPACAPR}
                tabRuoli={tabRuoli}
                editOpen={editOpen}
                posTicket={posTicket}
                ricRipe={ricRipe}
                onEditClose={onEditClose}
                onEditAskConfirm={onEditAskConfirm}
                editControl={editControl}
                specialitiesList={specialitiesList}
                entiList={entiList}
                filteredPerformances={filteredPerformances}
                getPerfSpecialita={getPerfSpecialita}
                setEditValue={setEditValue}
                pdfIconSrc={pdfIconBlack}
                onRequestEditPrestazione={onEditPrestazioneClick}
                selectedTab={selectedTab}
                onTabChange={handleTabChange}
                control={methodsDettaglioPrenotazione.control}
                handleSubmit={methodsDettaglioPrenotazione.handleSubmit}
                onSubmit={onSubmit}
                prestazioniRows={prestazioniDetails}
                prestazioniColumns={columnsTablePrestazioni}
                appuntamentiRows={appuntamentiDetails}
                appuntamentiColumns={columnsTableAppuntamenti}
                onSelectPrestazione={setSelectedAppointmentIDPACAPR}
                onClickUscita={handleOnClickUscita}
                onAskConferma={askConfirmEditPrenotazione}
                StoricoAnnullamenti={StoricoAnnullamenti}
                appuntamentiAnnullati={appuntamentiAnnullatiDetails}
                onDettaglioAnnullato={handleOnClickDettaglioAppuntamento}
                onRipristino={handleOnClickRipristinoAppuntamento}
                onCancellazioneFisica={
                  askConfirmCancellazioneFisicaAppuntamentoCancellato
                }
                iconCardSrc={iconCard}
                radioRowSx={radioRowSx}
                maxPriorityLength={400}
                localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
              />
            )}
          {
            <Modal open={showModaleAnnullamentoLogico}>
              <Box
                sx={{
                  maxHeight: "90vh",
                  maxWidth: "150vh",
                  width: "85%",
                  overflow: "auto",
                  paddingTop: 2,
                  backgroundColor: "white",
                  borderRadius: 2,
                  boxShadow: 24,
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <Tabs value={0} sx={{ paddingLeft: 2 }}>
                  <Tab
                    sx={{
                      fontFamily: "Montserrat",
                      fontWeight: "bold",
                      textTransform: "none",
                    }}
                    label="Cancellazione"
                  />
                </Tabs>

                <form
                  onSubmit={methodsFormCancellazione.handleSubmit(
                    onSubmitFormCancellazione
                  )}
                >
                  <Grid
                    container
                    spacing={2}
                    padding={2}
                    justifyContent="center"
                  >
                    <Grid item xs={2}>
                      <Controller
                        name="daPagare"
                        control={methodsFormCancellazione.control}
                        render={({ field }) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      />
                      Da pagare
                    </Grid>

                    <Grid item xs={2}>
                      <Controller
                        name="sospeso"
                        control={methodsFormCancellazione.control}
                        render={({ field }) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      />
                      Sospeso
                    </Grid>

                    <Grid item xs={8}></Grid>

                    <Grid item xs={12}>
                      <Controller
                        name="noteCancellazione"
                        control={methodsFormCancellazione.control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Note di cancellazione"
                            fullWidth
                            multiline
                            rows={3}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        gap={2}
                      >
                        <Button
                          variant="outlinedError"
                          onClick={() => setShowModaleAnnullamentoLogico(false)}
                        >
                          Uscita
                        </Button>

                        <Button type="submit" variant="contained">
                          Conferma Cancellazione
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Modal>
          }
          {dettaglioOpen === false &&
            dettaglioAnnullataOpen === false &&
            !showAppointmentDetail && (
              <>
                <Grid
                  display={"flex"}
                  justifyContent={"center"}
                  flexDirection={"column"}
                  item
                  xs={12}
                  lg={9}
                  xl={9}
                  marginBottom={3}
                >
                  <Accordion
                    sx={{ borderRadius: 1 }}
                    expanded={accordion}
                    onChange={() => setAccordion(!accordion)}
                    className={accordion ? "accordion" : ""}
                  >
                    <AccordionSummary
                      sx={{
                        "&:hover": {
                          borderTopRightRadius: 3,
                          borderTopLeftRadius: 3,
                          backgroundColor: "#2E83C4 !important",
                          color: "#FFFFFF !important",
                          "& .MuiAccordionSummary-expandIconWrapper": {
                            color: "#fff",
                          },
                          "& .svg-icon path": { fill: "#fff" },
                        },
                      }}
                      expandIcon={
                        <ArrowDropDownIcon
                          className={accordion ? "arrowDropDownIconWhite" : ""}
                        />
                      }
                      aria-controls="panel2-content"
                      id="panel2-header"
                    >
                      <Box display={"flex"} alignItems={"center"}>
                        <Grid
                          container
                          spacing={1}
                          alignItems={"flex-end"}
                          marginLeft={0}
                        >
                          <Grid item>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="svg-icon"
                            >
                              <g clipPath="url(#clip0_1760_6177)">
                                <path
                                  d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
                                  fill="#546E7A"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1760_6177">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </Grid>
                          <Grid item>
                            <Typography variant="h6" component="div">
                              Ricerca Appuntamenti
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </AccordionSummary>

                    <AccordionDetails>
                      <form
                        onSubmit={handleSubmit(onSubmit)}
                        className="form-research"
                      >
                        <Typography
                          variant="h6"
                          fontSize={14}
                          fontFamily={"Rubik"}
                          color={"rgba(0, 0, 0, 0.60)"}
                          fontWeight={500}
                        >
                          Selezionare le opzioni desiderate
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <Controller
                              name="nominativo"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="Inserire Cognome e Nome"
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={6} />

                          <Grid item xs={12} md={6}>
                            <Controller
                              name="cfPaziente"
                              control={control}
                              render={({ field }) =>
                                !is_codFisc_Valid ? (
                                  <TextField
                                    size="small"
                                    label="Errore"
                                    fullWidth
                                    inputProps={{ maxLength: 16 }}
                                    error
                                    helperText={message_coFisc_Message}
                                    {...field}
                                  />
                                ) : is_codFisc_Middle ? (
                                  <TextField
                                    size="small"
                                    label="Inserire Codice Fiscale"
                                    fullWidth
                                    inputProps={{ maxLength: 16 }}
                                    helperText="Campo da finire di compilare"
                                    sx={{
                                      "& .MuiFormHelperText-root": {
                                        color: "#FFAF42",
                                      },
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#FFAF42",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                          { borderColor: "#FFAF42" },
                                      },
                                      "& .MuiInputLabel-root": {
                                        "&.Mui-focused": { color: "#FFAF42" },
                                      },
                                    }}
                                    {...field}
                                  />
                                ) : (
                                  <TextField
                                    size="small"
                                    label="Inserire Codice Fiscale"
                                    fullWidth
                                    inputProps={{ maxLength: 16 }}
                                    onKeyDown={(e) => {
                                      const v = field.value || "";
                                      if (
                                        v.length >= 16 &&
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      )
                                        e.preventDefault();
                                    }}
                                    {...field}
                                  />
                                )
                              }
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={3}>
                            <Controller
                              name="dataNasPaziente"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="Data di Nascita"
                                  type="date"
                                  inputProps={{ max: "9999-12-31" }}
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            {/* <Controller
                              name="specialita"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="Inserire la Specialità"
                                  fullWidth
                                  {...field}
                                />
                              )}
                            /> */}
                            <RHFAutocomplete
                              name="specialita"
                              control={control}
                              size="small"
                              label="Inserire la Specialità"
                              options={[
                                "",
                                ...specialitiesList.map((s) => s.SPECIALITA),
                              ]}
                              getOptionLabel={(code: string) =>
                                code === ""
                                  ? ""
                                  : specialitiesList.find(
                                      (s) => s.SPECIALITA === code
                                    )?.DESCRIZIONE ?? code
                              }
                              isOptionEqualToValue={(o, v) => o === v}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Controller
                              name="impegnativa"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="Inserire il numero di impegnativa"
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Controller
                              name="numPrenotazione"
                              control={control}
                              render={({ field }) =>
                                !is_numPren_Valid ? (
                                  <TextField
                                    size="small"
                                    label="Errore"
                                    fullWidth
                                    inputProps={{ maxLength: 12 }}
                                    error
                                    helperText={message_numPren_Message}
                                    {...field}
                                  />
                                ) : is_numPren_Middle ? (
                                  <TextField
                                    size="small"
                                    label="Inserire Numero Prenotazione"
                                    fullWidth
                                    inputProps={{ maxLength: 12 }}
                                    helperText="Campo da finire di compilare"
                                    sx={{
                                      "& .MuiFormHelperText-root": {
                                        color: "#FFAF42",
                                      },
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#FFAF42",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                          { borderColor: "#FFAF42" },
                                      },
                                      "& .MuiInputLabel-root": {
                                        "&.Mui-focused": { color: "#FFAF42" },
                                      },
                                    }}
                                    {...field}
                                  />
                                ) : (
                                  <TextField
                                    size="small"
                                    label="Inserire Numero Prenotazione"
                                    fullWidth
                                    inputProps={{ maxLength: 12 }}
                                    {...field}
                                  />
                                )
                              }
                            />
                          </Grid>

                          {/* Range date per ricerca */}
                          <Grid item xs={12}>
                            <Typography
                              variant="h6"
                              fontSize={14}
                              fontFamily={"Rubik"}
                              color={"rgba(0, 0, 0, 0.60)"}
                              fontWeight={500}
                            >
                              Range date per ricerca
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Controller
                              name="tipoDate"
                              control={control}
                              render={({ field }) => (
                                <RadioGroup {...field} row sx={radioRowSx}>
                                  <Grid
                                    container
                                    spacing={1}
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Grid item md={6}>
                                      <FormControlLabel
                                        defaultChecked
                                        value="V"
                                        control={<Radio size="small" />}
                                        label="Visita"
                                      />
                                    </Grid>
                                    <Grid item md={6}>
                                      <FormControlLabel
                                        value="P"
                                        control={<Radio size="small" />}
                                        label="Prenotazione"
                                      />
                                    </Grid>
                                  </Grid>
                                </RadioGroup>
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Controller
                              name="dataIni"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="Data di Inizio"
                                  type="date"
                                  inputProps={{ max: "9999-12-31" }}
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Controller
                              name="dataFin"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="Data di Fine"
                                  type="date"
                                  inputProps={{
                                    min: getValues("dataIni") ?? null,
                                    max: "9999-12-31",
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>

                          {/* --- Righe “di prima”: IUP/IURP + codice, poi Attive/Sospese/Annullate --- */}
                          {permissions.visualizzaCodiceSISS === "1" && (
                            <Grid item xs={12} md={4}>
                              <Controller
                                name="tipoCodSISS"
                                control={control}
                                render={({ field }) => (
                                  <RadioGroup {...field} row sx={radioRowSx}>
                                    <Grid
                                      container
                                      spacing={1}
                                      justifyContent="space-between"
                                      alignItems="center"
                                    >
                                      <Grid item md={6}>
                                        <FormControlLabel
                                          value="IUP"
                                          control={<Radio size="small" />}
                                          label="Codice IUP"
                                        />
                                      </Grid>
                                      <Grid item md={6}>
                                        <FormControlLabel
                                          value="IURP"
                                          control={<Radio size="small" />}
                                          label="Codice IURP"
                                        />
                                      </Grid>
                                    </Grid>
                                  </RadioGroup>
                                )}
                              />
                            </Grid>
                          )}
                          <Grid item xs={12} md={4}>
                            <Controller
                              name="codSISS"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  label="scrivere il codice..."
                                  fullWidth
                                  {...field}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} />

                          <Grid item xs={12}>
                            <Controller
                              name="tipoApp"
                              control={control}
                              render={({ field }) => (
                                <RadioGroup {...field} row sx={radioRowSx}>
                                  <Grid
                                    container
                                    spacing={1}
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Grid item md={2}>
                                      <FormControlLabel
                                        value="A"
                                        control={
                                          <Radio
                                            size="small"
                                            onClick={(event) => {
                                              event.preventDefault();

                                              const oldValue =
                                                getValues("tipoApp");
                                              const currentValue = "A";

                                              setValue(
                                                "tipoApp",
                                                oldValue === currentValue
                                                  ? ""
                                                  : currentValue,
                                                {
                                                  shouldDirty: true,
                                                  shouldTouch: true,
                                                }
                                              );
                                            }}
                                          />
                                        }
                                        label="Attive"
                                      />
                                    </Grid>
                                    <Grid item md={2}>
                                      <FormControlLabel
                                        value="S"
                                        control={
                                          <Radio
                                            size="small"
                                            onClick={(event) => {
                                              event.preventDefault();

                                              const oldValue =
                                                getValues("tipoApp");
                                              const currentValue = "S";

                                              setValue(
                                                "tipoApp",
                                                oldValue === currentValue
                                                  ? ""
                                                  : currentValue,
                                                {
                                                  shouldDirty: true,
                                                  shouldTouch: true,
                                                }
                                              );
                                            }}
                                          />
                                        }
                                        label="Sospese"
                                      />
                                    </Grid>
                                    <Grid item md={2}>
                                      <FormControlLabel
                                        value="C"
                                        control={
                                          <Radio
                                            size="small"
                                            onClick={(event) => {
                                              event.preventDefault();

                                              const oldValue =
                                                getValues("tipoApp");
                                              const currentValue = "C";

                                              setValue(
                                                "tipoApp",
                                                oldValue === currentValue
                                                  ? ""
                                                  : currentValue,
                                                {
                                                  shouldDirty: true,
                                                  shouldTouch: true,
                                                }
                                              );
                                            }}
                                          />
                                        }
                                        label="Annullate"
                                      />
                                    </Grid>
                                    <Grid item md={6}></Grid>
                                  </Grid>
                                </RadioGroup>
                              )}
                            />
                          </Grid>

                          {/* --- RIGA “sinistra vs destra” sulla stessa linea: a sinistra i radio “Tutte…”, a destra Aziende --- */}
                          <Grid item xs={showCompanies === "1" ? 8 : 12}>
                            <Grid container display={"flex"} justifyContent={"flex-start"} justifyItems={"flex-start"} >
                              <Grid item xs={12} height={"auto"}>
                                {/* Tutte / Sys Clinique / Gp++ / Web */}
                                <Typography
                                  variant="h6"
                                  fontSize={14}
                                  fontFamily={"Rubik"}
                                  color={"rgba(0, 0, 0, 0.60)"}
                                  fontWeight={500}
                                >
                                  Origine
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Grid
                                  container
                                  display={"flex"}
                                  height={"100%"}
                                >
                                  <Grid item xs={12}>
                                    <Controller
                                      name="origine"
                                      control={control}
                                      defaultValue="tutte"
                                      render={({ field }) => (
                                        <RadioGroup
                                          {...field}
                                          row
                                          sx={radioRowSx}
                                        >
                                          <Grid
                                            container
                                            spacing={1}
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                            <Grid item md={3}>
                                              <FormControlLabel
                                                value="tutte"
                                                control={<Radio size="small" />}
                                                label="Tutte"
                                              />
                                            </Grid>
                                            <Grid item md={3}>
                                              <FormControlLabel
                                                value="P"
                                                control={<Radio size="small" />}
                                                label="Sys Clinique"
                                              />
                                            </Grid>
                                            {permissions.abilitaOrigineGP ===
                                              "1" && (
                                              <Grid item md={3}>
                                                <FormControlLabel
                                                  value="X"
                                                  control={
                                                    <Radio size="small" />
                                                  }
                                                  label="Gp++"
                                                />
                                              </Grid>
                                            )}
                                            <Grid item md={3}>
                                              <FormControlLabel
                                                value="W"
                                                control={<Radio size="small" />}
                                                label="Web"
                                              />
                                            </Grid>

                                            {permissions.abilitaOrigineFlussoMTA ===
                                              "1" && (
                                              <Grid item md={3}>
                                                <FormControlLabel
                                                  value="MTA"
                                                  control={
                                                    <Radio size="small" />
                                                  }
                                                  label="Flusso MTA"
                                                />
                                              </Grid>
                                            )}
                                            {permissions.abilitaOrigineEclaim ===
                                              "1" && (
                                              <Grid item md={3}>
                                                <FormControlLabel
                                                  value="ECLAIM"
                                                  control={
                                                    <Radio size="small" />
                                                  }
                                                  label="Eclaim"
                                                />
                                              </Grid>
                                            )}

                                            <Grid item md={3}>
                                              <FormControlLabel
                                                value="T"
                                                control={<Radio size="small" />}
                                                label="Tuo Tempo"
                                              />
                                            </Grid>
                                            {permissions.abilitaOrigineG2 ===
                                              "1" && (
                                              <Grid item md={3}>
                                                <FormControlLabel
                                                  value="g2"
                                                  control={
                                                    <Radio size="small" />
                                                  }
                                                  label="G2"
                                                />
                                              </Grid>
                                            )}
                                          </Grid>
                                        </RadioGroup>
                                      )}
                                    />
                                  </Grid>
                                  <Grid item xs={12} mt={2}>
                                    {/* Ricerca ID */}
                                    <Controller
                                      name="ricercaId"
                                      control={control}
                                      disabled={disabled}
                                      defaultValue=""
                                      render={({ field }) => (
                                        <TextField
                                          size="small"
                                          placeholder="Ricerca ID"
                                          fullWidth
                                          {...field}
                                        />
                                      )}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* DESTRA (md=4): Aziende, allineata alla riga “Tutte …” e alla colonna della “Data di Fine” */}
                          {showCompanies === "1" && (
                            <Grid item xs={4}>
                              <Typography
                                variant="h6"
                                fontSize={14}
                                fontFamily={"Rubik"}
                                color={"rgba(0, 0, 0, 0.60)"}
                                fontWeight={500}
                              >
                                Aziende
                              </Typography>
                              <Controller
                                name="entiSelezionati"
                                control={control}
                                defaultValue={[]}
                                render={({ field }) => (
                                  <Box sx={{ width: "100%", height: "auto" }}>
                                    <Paper sx={listPaperSx}>
                                      <List dense disablePadding>
                                        {entiOptions.map((opt) => {
                                          const checked = (
                                            field.value || []
                                          ).includes(opt);
                                          const toggle = () => {
                                            const cur = field.value || [];
                                            field.onChange(
                                              checked
                                                ? cur.filter(
                                                    (v: string) => v !== opt
                                                  )
                                                : [...cur, opt]
                                            );
                                          };
                                          return (
                                            <ListItemButton
                                              key={opt}
                                              onClick={toggle}
                                              dense
                                              disableGutters
                                              selected={checked}
                                              sx={listItemSx}
                                            >
                                              <ListItemIcon
                                                sx={{
                                                  minWidth: 0,
                                                  mr: 1,
                                                  p: 1,
                                                }}
                                              >
                                                <Checkbox
                                                  edge="start"
                                                  checked={checked}
                                                  tabIndex={-1}
                                                  disableRipple
                                                  color="primary"
                                                  size="small"
                                                  sx={{ p: 0.25 }}
                                                />
                                              </ListItemIcon>
                                              <ListItemText primary={opt} />
                                            </ListItemButton>
                                          );
                                        })}
                                      </List>
                                    </Paper>
                                  </Box>
                                )}
                              />
                            </Grid>
                          )}

                          {/* Bottoni */}
                          <Grid item xs={12} className="button-group">
                            <Button
                              variant="outlined"
                              onClick={handleResetForm}
                              className="button-reset"
                            >
                              Reset Filtri
                            </Button>
                            <Button
                              type="submit"
                              style={{ fontWeight: "bold" }}
                              variant="contained"
                              className="button-new-search"
                              disabled={isDisabled}
                            >
                              Ricerca Appuntamento
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    </AccordionDetails>
                  </Accordion>

                  {!loadingData &&
                    hasSearched &&
                    groupedAppointmentData.length === 0 && (
                      <Box>
                        <Grid>
                          <Grid item xs={12} lg={12} xl={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "3em",
                                fontSize: "1.1rem",
                                borderRadius: "8px",
                                marginTop: 2,
                                textAlign: "center",
                                backgroundColor: "#FFDF77",
                              }}
                            >
                              <Typography variant="body1">
                                La ricerca non ha prodotto risultati
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}

                  {/* Spinner visualizzato durante il caricamento */}
                  {loadingData && (
                    <Box
                      sx={{
                        position: "fixed", // Per coprire tutta la view, anche dei modali
                        inset: 0,
                        display: "grid",
                        placeItems: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                        zIndex: (theme) => theme.zIndex.modal + 1, // > 1300 (più alto del valore dei modali)
                      }}
                    >
                      <CircularProgress size="6rem" />
                    </Box>
                  )}

                  {groupedAppointmentData.length > 0 && (
                    <>
                      <Grid
                        flexDirection={"row"}
                        justifyContent={"center"}
                        sx={
                          !accordion
                            ? { marginBottom: 2, marginTop: 2 }
                            : { marginBottom: 2 }
                        }
                      >
                        <Grid item xs={12} lg={9} xl={9}>
                          <TableContainer
                            sx={{
                              height: "auto",
                              display: "flex",
                              justifyContent: "center",
                              justifyItems: "center",
                              maxHeight: "90vh",
                              overflow: "auto",
                            }}
                          >
                            <Table aria-label="caption table" stickyHeader>
                              <TableHead>
                                <TableRow
                                  sx={{
                                    "& th": {
                                      backgroundColor: "#2E83C4", // Colore del testo
                                      color: "#fff !important",
                                    },
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      width: "5%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Numero
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      width: "5%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Data
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      width: "8%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Paziente
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      width: "4%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Nascita
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      width: "4%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Agenda
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "start",
                                      width: "2%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Azienda
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      width: "3%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Stato
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      width: "2%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    Azioni
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      width: "0.5%",
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  ></TableCell>
                                </TableRow>
                              </TableHead>
                              {groupedAppointmentData.length > 0
                                ? groupedAppointmentData.map(
                                    (appointment, index) => {
                                      const appointmentState =
                                        getAppointmentState(appointment);

                                      return (
                                        <React.Fragment key={appointment.NUMERO_PRENOTAZIONE}>
                                          <TableBody>
                                            <TableRow
                                              sx={
                                                index % 2 === 0
                                                  ? { backgroundColor: "#fff" }
                                                  : { background: "#f0f9ff" }
                                              }
                                            >
                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent:
                                                      "flex-start",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  {
                                                    appointment.NUMERO_PRENOTAZIONE
                                                  }
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent:
                                                      "flex-start",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  {dayjs(
                                                    appointment.DATAPRENOTAZIONE
                                                  ).format("DD/MM/YY")}
                                                </Box>
                                              </TableCell>

                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent:
                                                      "flex-start",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  {appointment.NOME_PAZIENTE}
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  {dayjs(
                                                    appointment.DATA_NASCITA
                                                  ).isValid()
                                                    ? dayjs(
                                                        appointment.DATA_NASCITA
                                                      ).format("DD/MM/YYYY")
                                                    : "Non disponibile"}
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  {appointment.TIPO_AGENDA}
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent:
                                                      "flex-start",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  {
                                                    appointment.AZIENDAPRENOTAZIONE
                                                  }
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 0.5,
                                                  }}
                                                >
                                                  <CircleIcon
                                                    sx={{
                                                      height: {
                                                        md: 15,
                                                      },
                                                      width: {
                                                        md: 15,
                                                      },
                                                      marginBottom: 0.3,
                                                    }}
                                                    color={getStatusColor(
                                                      appointmentState
                                                    )}
                                                  />
                                                  {appointmentState}
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{ textAlign: "center" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: "100%",
                                                    width: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <Tooltip
                                                    title={"Stampa riepilogo"}
                                                  >
                                                    <IconButton
                                                      onClick={() => {
                                                        assignedAppointmentToPrint(
                                                          appointment.NUMERO_PRENOTAZIONE
                                                        );
                                                      }}
                                                    >
                                                      <Box
                                                        component="img"
                                                        sx={{
                                                          height: 24,
                                                          width: 24,
                                                        }}
                                                        src={pdfIconBlack}
                                                        alt="Stampa PDF"
                                                      />
                                                    </IconButton>
                                                  </Tooltip>
                                                  {appointmentState !==
                                                    "Cancellata" && (
                                                    <Tooltip title={"Cancella"}>
                                                      <IconButton
                                                        onClick={() => {
                                                          assignedAppointmentToDelete(
                                                            Number(
                                                              appointment.IDPACATA
                                                            )
                                                          );
                                                          setShowAllertDelete(
                                                            true
                                                          );
                                                        }}
                                                      >
                                                        <Box
                                                          component="img"
                                                          sx={{
                                                            height: 24,
                                                            width: 24,
                                                          }}
                                                          src={redTrashBin}
                                                          alt="Cancella"
                                                        />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                  {/* MODIFICA - MATITA NERA DOPO IL CESTINO */}
                                                  {(() => {
                                                    return (
                                                      <>
                                                        {permissions.abilitaModifica ===
                                                          "1" && (
                                                          <Tooltip
                                                            title={"Dettaglio"}
                                                          >
                                                            {/* span per permettere il tooltip anche quando disabled */}
                                                            <span>
                                                              <IconButton
                                                                onClick={() => {
                                                                  setRiferimentiIDs(
                                                                    {
                                                                      azienda:
                                                                        appointment.AZIENDAPRENOTAZIONE,
                                                                      numPrenotazione:
                                                                        appointment.NUMERO_PRENOTAZIONE,
                                                                      idpacapr:
                                                                        appointment.IDPACAPR,
                                                                      idpacate:
                                                                        appointment.IDPACATA,
                                                                    }
                                                                  );
                                                                }}
                                                              >
                                                                <Box
                                                                  component="img"
                                                                  sx={{
                                                                    height: 24,
                                                                    width: 24,
                                                                  }}
                                                                  src={
                                                                    blackPencil
                                                                  }
                                                                  alt="Modifica"
                                                                />
                                                              </IconButton>
                                                            </span>
                                                          </Tooltip>
                                                        )}
                                                      </>
                                                    );
                                                  })()}
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  display: "flex",
                                                  alignContent: "center",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                {appointmentState ===
                                                  "Attiva" && (
                                                  <IconButton
                                                    aria-label="expand row"
                                                    size="small"
                                                    onClick={() => {
                                                      handlePrenotazioneToShow(
                                                        appointment.NUMERO_PRENOTAZIONE
                                                      );
                                                    }}
                                                  >
                                                    {expandPrenotazione ===
                                                    appointment.NUMERO_PRENOTAZIONE ? (
                                                      <KeyboardArrowUpIcon />
                                                    ) : (
                                                      <KeyboardArrowDownIcon />
                                                    )}
                                                  </IconButton>
                                                )}
                                              </TableCell>
                                            </TableRow>

                                            <TableRow>
                                              <TableCell
                                                colSpan={12}
                                                sx={{ padding: 0 }}
                                              >
                                                <Collapse
                                                  sx={
                                                    index % 2 === 0
                                                      ? {
                                                          backgroundColor:
                                                            "#fff",
                                                          padding: 2,
                                                        }
                                                      : {
                                                          background: "#f0f9ff",
                                                          padding: 2,
                                                        }
                                                  }
                                                  in={
                                                    expandPrenotazione ===
                                                    appointment.NUMERO_PRENOTAZIONE
                                                  }
                                                  timeout="auto"
                                                  unmountOnExit
                                                >
                                                  <Box
                                                    sx={
                                                      index % 2 === 0
                                                        ? {
                                                            background: "#fff",
                                                          }
                                                        : {
                                                            background:
                                                              "#f2f8fc",
                                                          }
                                                    }
                                                  >
                                                    {appointment.GRUPPO_PRESTAZIONI.map(
                                                      (prestazione, index2) => {
                                                        const temp =
                                                          index.toString() +
                                                          index2.toString();

                                                        if (
                                                          prestazione
                                                            .GRUPPO_APPUNTAMENTI
                                                            .length === 1
                                                        ) {
                                                          return (
                                                            <Box
                                                              key={temp}
                                                              display={"flex"}
                                                              justifyContent={
                                                                "space-between"
                                                              }
                                                              sx={{
                                                                backgroundColor:
                                                                  "#fff",
                                                                border:
                                                                  "1px solid #CCC",
                                                                borderRadius: 1,
                                                                paddingTop: 1,
                                                                paddingBottom: 1,
                                                                paddingLeft: 2,
                                                                paddingRight: 2,
                                                                marginTop: 1,
                                                                marginBottom: 1,
                                                              }}
                                                            >
                                                              <Typography
                                                                component="span"
                                                                alignContent={
                                                                  "center"
                                                                }
                                                              >
                                                                {
                                                                  prestazione.DESCRIZIONE_PRESTAZIONE
                                                                }{" "}
                                                                (1 Visita)
                                                                <Box
                                                                  fontWeight="bold"
                                                                  display="inline"
                                                                >
                                                                  {" "}
                                                                  - Medico:{" "}
                                                                  {
                                                                    prestazione
                                                                      .GRUPPO_APPUNTAMENTI[0]
                                                                      .NOMEMEDICO
                                                                  }{" "}
                                                                  - Data Visita:{" "}
                                                                  {dayjs(
                                                                    prestazione
                                                                      .GRUPPO_APPUNTAMENTI[0]
                                                                      .DATAESAME
                                                                  ).format(
                                                                    `DD/MM/YYYY`
                                                                  )}{" "}
                                                                  - Ora:{" "}
                                                                  {formatHour(
                                                                    prestazione
                                                                      .GRUPPO_APPUNTAMENTI[0]
                                                                      .ORAESAME
                                                                  )}{" "}
                                                                  {/* - Stato prestazione:{" "}
                                                      {
                                                        prestazione
                                                          .GRUPPO_APPUNTAMENTI[0]
                                                          .STATOPRENOTAZIONE
                                                      }{" "} */}
                                                                </Box>
                                                              </Typography>
                                                              {prestazione
                                                                .GRUPPO_APPUNTAMENTI[0]
                                                                .STATOPRENOTAZIONE ===
                                                                "Attiva" && (
                                                                <Box>
                                                                  {permissions.abilitaSpostamento ===
                                                                    "1" && (
                                                                    <Tooltip
                                                                      title={
                                                                        "Spostamento"
                                                                      }
                                                                    >
                                                                      <IconButton
                                                                        onClick={() => {
                                                                          setShowAllertEdit(
                                                                            true
                                                                          );
                                                                          assignedAppointmentToEdit(
                                                                            prestazione
                                                                              .GRUPPO_APPUNTAMENTI[0],
                                                                            prestazione
                                                                          );
                                                                        }}
                                                                      >
                                                                        <CardMedia
                                                                          component="img"
                                                                          sx={{
                                                                            height:
                                                                              {
                                                                                md: 20,
                                                                              },
                                                                            width:
                                                                              {
                                                                                md: 20,
                                                                              },
                                                                          }}
                                                                          image={
                                                                            changeAppointmentIcon
                                                                          }
                                                                        />
                                                                      </IconButton>
                                                                    </Tooltip>
                                                                  )}
                                                                  <Tooltip
                                                                    title={
                                                                      "Cancella"
                                                                    }
                                                                  >
                                                                    <IconButton
                                                                      onClick={() => {
                                                                        assignedAppointmentToDelete(
                                                                          Number(
                                                                            0
                                                                          ),
                                                                          Number(
                                                                            prestazione
                                                                              .GRUPPO_APPUNTAMENTI[0]
                                                                              .IDPACAPR
                                                                          ),
                                                                          Number(
                                                                            prestazione
                                                                              .GRUPPO_APPUNTAMENTI[0]
                                                                              .IDPACADA
                                                                          )
                                                                        );
                                                                        setShowModaleAnnullamentoLogico(
                                                                          true
                                                                        );
                                                                      }}
                                                                    >
                                                                      <CardMedia
                                                                        component="img"
                                                                        sx={{
                                                                          height:
                                                                            {
                                                                              md: 20,
                                                                            },
                                                                          width:
                                                                            {
                                                                              md: 20,
                                                                            },
                                                                        }}
                                                                        image={
                                                                          redTrashBin
                                                                        }
                                                                      />
                                                                    </IconButton>
                                                                  </Tooltip>
                                                                </Box>
                                                              )}
                                                            </Box>
                                                          );
                                                        }

                                                        return (
                                                          <Accordion
                                                            key={temp}
                                                            sx={{
                                                              marginBottom: 2,
                                                              border:
                                                                "1px solid #CCC",
                                                            }}
                                                            expanded={
                                                              expanded === temp
                                                            }
                                                            onChange={() =>
                                                              handleAccordionToShow(
                                                                temp
                                                              )
                                                            }
                                                          >
                                                            <AccordionSummary
                                                              expandIcon={
                                                                <ArrowDropDownIcon />
                                                              }
                                                            >
                                                              <Typography>
                                                                {
                                                                  prestazione.DESCRIZIONE_PRESTAZIONE
                                                                }
                                                                <>
                                                                  {" "}
                                                                  <Typography
                                                                    component="span"
                                                                    fontWeight="bold"
                                                                  >
                                                                    ciclo:{" "}
                                                                    {(() => {
                                                                      const attivi =
                                                                        prestazione.GRUPPO_APPUNTAMENTI.filter(
                                                                          (
                                                                            app
                                                                          ) =>
                                                                            app.STATOPRENOTAZIONE ===
                                                                            "Attiva"
                                                                        ).length;
                                                                      return `${attivi} ${
                                                                        attivi ===
                                                                        1
                                                                          ? "appuntamento attivo"
                                                                          : "appuntamenti attivi"
                                                                      }`;
                                                                    })()}
                                                                  </Typography>
                                                                </>
                                                              </Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                              <Box
                                                                key={index}
                                                                sx={{
                                                                  padding: 1,
                                                                  margin: 1,
                                                                }}
                                                              >
                                                                <TableContainer
                                                                  sx={{
                                                                    display:
                                                                      "flex",
                                                                    flexDirection:
                                                                      "column",
                                                                    alignItems:
                                                                      "flex-start",
                                                                    alignSelf:
                                                                      "stretch",
                                                                    borderRadius:
                                                                      "2px",
                                                                    borderTop:
                                                                      "1px solid #CCC",
                                                                    borderBottom:
                                                                      "1px solid #CCC",
                                                                    background:
                                                                      "#F9F9F9",
                                                                  }}
                                                                >
                                                                  <Table>
                                                                    <TableHead>
                                                                      <TableRow>
                                                                        {headlines.map(
                                                                          (
                                                                            element,
                                                                            key
                                                                          ) => {
                                                                            return (
                                                                              <TableCell
                                                                                key={
                                                                                  key
                                                                                }
                                                                                sx={{
                                                                                  background:
                                                                                    "#00000000",
                                                                                  borderRight:
                                                                                    "1px solid #CCC",
                                                                                  borderLeft:
                                                                                    "1px solid #CCC",
                                                                                  borderBottom:
                                                                                    "1px solid #CCC",
                                                                                  color:
                                                                                    "#000000",
                                                                                  fontStyle:
                                                                                    "normal",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  element
                                                                                }
                                                                              </TableCell>
                                                                            );
                                                                          }
                                                                        )}
                                                                      </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                      {prestazione.GRUPPO_APPUNTAMENTI.map(
                                                                        (
                                                                          appuntamento,
                                                                          idAppuntamento
                                                                        ) => {
                                                                          return (
                                                                            <TableRow
                                                                              key={
                                                                                idAppuntamento
                                                                              }
                                                                              sx={
                                                                                idAppuntamento %
                                                                                  2 ===
                                                                                0
                                                                                  ? {
                                                                                      background:
                                                                                        "#fff",
                                                                                    }
                                                                                  : {}
                                                                              }
                                                                            >
                                                                              <TableCell
                                                                                component="th"
                                                                                scope="row"
                                                                                sx={{
                                                                                  borderRight:
                                                                                    "1px solid #CCC",
                                                                                  borderLeft:
                                                                                    "1px solid #CCC",
                                                                                }}
                                                                              >
                                                                                {dayjs(
                                                                                  appuntamento.DATAESAME
                                                                                ).format(
                                                                                  `DD/MM/YYYY`
                                                                                )}
                                                                              </TableCell>
                                                                              <TableCell
                                                                                sx={{
                                                                                  borderRight:
                                                                                    "1px solid #CCC",
                                                                                  borderLeft:
                                                                                    "1px solid #CCC",
                                                                                }}
                                                                              >
                                                                                {formatHour(
                                                                                  appuntamento.ORAESAME
                                                                                )}
                                                                              </TableCell>
                                                                              <TableCell
                                                                                sx={{
                                                                                  borderRight:
                                                                                    "1px solid #CCC",
                                                                                  borderLeft:
                                                                                    "1px solid #CCC",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  appuntamento.NOMEMEDICO
                                                                                }
                                                                              </TableCell>
                                                                              <TableCell
                                                                                sx={{
                                                                                  borderRight:
                                                                                    "1px solid #CCC",
                                                                                  borderLeft:
                                                                                    "1px solid #CCC",
                                                                                }}
                                                                              >
                                                                                {appuntamento.DURATAESAME +
                                                                                  " min"}
                                                                              </TableCell>
                                                                              <TableCell
                                                                                sx={{
                                                                                  borderRight:
                                                                                    "1px solid #CCC",
                                                                                  borderLeft:
                                                                                    "1px solid #CCC",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  appuntamento.STATOPRENOTAZIONE
                                                                                }
                                                                              </TableCell>
                                                                              {
                                                                                <TableCell
                                                                                  sx={{
                                                                                    borderRight:
                                                                                      "1px solid #CCC",
                                                                                    borderLeft:
                                                                                      "1px solid #CCC",
                                                                                  }}
                                                                                >
                                                                                  {appuntamento.STATOPRENOTAZIONE ===
                                                                                    "Attiva" && (
                                                                                    <Box
                                                                                      sx={{
                                                                                        display:
                                                                                          "flex",
                                                                                        gap: 2,
                                                                                      }}
                                                                                    >
                                                                                      <Tooltip
                                                                                        title={
                                                                                          "Cancella"
                                                                                        }
                                                                                      >
                                                                                        <IconButton
                                                                                          onClick={() => {
                                                                                            assignedAppointmentToDelete(
                                                                                              Number(
                                                                                                appuntamento.IDPACATE
                                                                                              ),
                                                                                              Number(
                                                                                                appuntamento.IDPACAPR
                                                                                              ),
                                                                                              Number(
                                                                                                appuntamento.IDPACADA
                                                                                              )
                                                                                            );
                                                                                            setShowModaleAnnullamentoLogico(
                                                                                              true
                                                                                            );
                                                                                          }}
                                                                                        >
                                                                                          <CardMedia
                                                                                            component="img"
                                                                                            sx={{
                                                                                              height:
                                                                                                {
                                                                                                  md: 20,
                                                                                                },
                                                                                              width:
                                                                                                {
                                                                                                  md: 20,
                                                                                                },
                                                                                            }}
                                                                                            image={
                                                                                              redTrashBin
                                                                                            }
                                                                                          />
                                                                                        </IconButton>
                                                                                      </Tooltip>
                                                                                      {permissions.abilitaSpostamento ===
                                                                                        "1" && (
                                                                                        <Tooltip
                                                                                          title={
                                                                                            "Spostamento"
                                                                                          }
                                                                                        >
                                                                                          <IconButton
                                                                                            onClick={() => {
                                                                                              setShowAllertEdit(
                                                                                                true
                                                                                              );
                                                                                              assignedAppointmentToEdit(
                                                                                                appuntamento,
                                                                                                prestazione
                                                                                              );
                                                                                            }}
                                                                                          >
                                                                                            <CardMedia
                                                                                              component="img"
                                                                                              sx={{
                                                                                                height:
                                                                                                  {
                                                                                                    md: 20,
                                                                                                  },
                                                                                                width:
                                                                                                  {
                                                                                                    md: 20,
                                                                                                  },
                                                                                              }}
                                                                                              image={
                                                                                                changeAppointmentIcon
                                                                                              }
                                                                                            />
                                                                                          </IconButton>
                                                                                        </Tooltip>
                                                                                      )}
                                                                                    </Box>
                                                                                  )}
                                                                                </TableCell>
                                                                              }
                                                                            </TableRow>
                                                                          );
                                                                        }
                                                                      )}
                                                                    </TableBody>
                                                                  </Table>
                                                                </TableContainer>
                                                              </Box>
                                                            </AccordionDetails>
                                                          </Accordion>
                                                        );
                                                      }
                                                    )}
                                                  </Box>
                                                </Collapse>
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </React.Fragment>
                                      );
                                    }
                                  )
                                : null}
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {!loadingData && appointmentData.length === 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: "0.3",
                      }}
                    >
                      <svg
                        width="552.5"
                        height="442"
                        viewBox="0 0 250 200"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M207 65C210.866 65 214 68.134 214 72C214 75.866 210.866 79 207 79H167C170.866 79 174 82.134 174 86C174 89.866 170.866 93 167 93H189C192.866 93 196 96.134 196 100C196 103.866 192.866 107 189 107H178.826C173.952 107 170 110.134 170 114C170 116.577 172 118.911 176 121C179.866 121 183 124.134 183 128C183 131.866 179.866 135 176 135H93C89.134 135 86 131.866 86 128C86 124.134 89.134 121 93 121H54C50.134 121 47 117.866 47 114C47 110.134 50.134 107 54 107H94C97.866 107 101 103.866 101 100C101 96.134 97.866 93 94 93H69C65.134 93 62 89.866 62 86C62 82.134 65.134 79 69 79H109C105.134 79 102 75.866 102 72C102 68.134 105.134 65 109 65H207ZM207 93C210.866 93 214 96.134 214 100C214 103.866 210.866 107 207 107C203.134 107 200 103.866 200 100C200 96.134 203.134 93 207 93Z"
                          fill="#8DBEE94D"
                        />
                        <path
                          d="M120.5 133C139.002 133 154 118.002 154 99.5C154 80.9985 139.002 66 120.5 66C101.998 66 87 80.9985 87 99.5C87 118.002 101.998 133 120.5 133Z"
                          fill="none"
                          stroke="#2E83C4"
                          strokeWidth="2.5"
                        />
                        <path
                          d="M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096"
                          stroke="#2E83C4"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M103.797 120.075C105.945 121.821 108.372 123.237 111.001 124.247"
                          stroke="#2E83C4"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M148 126L154 132"
                          stroke="#2E83C4"
                          strokeWidth="2.5"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M153.03 131.03C151.138 132.923 151.138 135.992 153.03 137.885L164.116 148.97C166.008 150.863 169.077 150.863 170.97 148.97C172.863 147.077 172.863 144.008 170.97 142.116L159.885 131.03C157.992 129.138 154.923 129.138 153.03 131.03Z"
                          fill="#56A6EF80"
                          stroke="#2E83C4"
                          strokeWidth="2.5"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M114 88C114 99.598 123.402 109 135 109C137.278 109 139.472 108.637 141.526 107.966C138.173 116.287 130.023 122.161 120.5 122.161C107.985 122.161 97.8394 112.015 97.8394 99.5C97.8394 88.1596 106.17 78.7648 117.045 77.1011C115.113 80.2793 114 84.0097 114 88Z"
                          fill="#56A6EF80"
                        />
                        <path
                          d="M121 81C119.727 81 118.482 81.1253 117.279 81.3642M113.645 82.4761C106.804 85.3508 102 92.1144 102 100"
                          stroke="#56A6EF"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M180.5 92H163.324M187.5 92H185.279M174.176 99.7773H166"
                          stroke="#56A6EF"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M84.1758 121.777H76M79.5 113H62.3242H79.5ZM56.5 113H52.2788H56.5Z"
                          stroke="#56A6EF"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Box>
                  )}
                </Grid>
              </>
            )}

          <AllertConfirmDelete
            showAllertDelete={showAllertDelete}
            setAllertDelete={setShowAllertDelete}
            handleDeleteConfirmation={handleDeleteConfirmation}
          />
          <AllertConfirmEdit
            showAllertEdit={showAllertEdit}
            appointmentToEdit={appointmentToEdit}
            appointmentsList={appointmentsList}
            setAllertEdit={setShowAllertEdit}
            handleEditConfirmation={handleEditConfirmation}
          />
        </>
      )}
    </Box>
  );
};

export default AppointmentResearch;
